// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { BiImport } from 'react-icons/bi';
// import { CiSearch } from 'react-icons/ci';
// import { FaFilter, FaEye, FaChevronRight, FaChevronLeft, FaPlus, FaTrash, FaCheck, FaDatabase } from 'react-icons/fa';
// import stocksData from '../data/stock';
// import updatestocksApi from '../data/stockhistory';
// import settingapi from '../data/setting';
// import axios from 'axios';
// import { useLocation } from 'react-router-dom';

// // ─── Types ────────────────────────────────────────────────────────────────────

// type StockCategoryObj = {
//   id: number;
//   stock_name: string;
//   category: string;
//   unit: string;
//   total_amount: string;
//   indirect_charges: string;
//   perUnitCharge: string;
//   investment_type: string;
// };

// type WithdrawalRecord = {
//   id: number;
//   party_id: number;
//   amount: number;
//   date: string;
//   catrgories: string;
// };

// type SellStockRecord = {
//   id: number;
//   party_id: number;
//   category: string;
//   stock_id: string;
//   stock_name: string;
//   sell_units: string;
//   sell_amount: string;
//   indirect_charges: string;
//   date: string;
//   catrgories: string;
// };

// interface Party {
//   id: number;
//   date: string;
//   name: string;
//   display_name: string;
//   number: string;
//   contact_person_name: string;
//   contact_person_number: string;
//   categories: string[];
//   total_amount?: number | string;
// }

// type PartyStockDBType = {
//   id: number | string;
//   party_id: number | string;
//   categories: string | StockCategoryObj[];
//   date?: string;
//   date_of_purchase?: string;
// };

// type StockCurrentAmountRecord = {
//   id: number;
//   stock_id: number;
//   cat_id: number;
//   current_price: number | string;
//   current_price_date: string;
//   sundry_creditors?: number;
// };

// interface IndexPriceRecord {
//   id: number;
//   niftyPrice?: string;
//   sensexPrice?: string;
//   date: string;
// }

// type FinancialEntry = {
//   id?: number;
//   party_id: string;
//   record_type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
//   amount: string;
//   date: string;
//   label?: string;
//   stock_name?: string;
//   category?: string;
//   units?: string;
// };

// type ModalSheetView = 'overall' | 'final' | 'balance' | 'QTLY Performance';
// type StockType = 'all' | 'equity' | 'mutual' | 'fno' | 'direct' | 'structure';
// type EntryType = 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
// type WizardStep = 1 | 2 | 3 | 4;

// type CalculationFormulaConfig = {
//   purchaseShare: boolean;
//   purchaseDirect: boolean;
//   grossSaleCharges: boolean;
//   grossInterestCharges: boolean;
//   indInterestCharges: boolean;
//   indPurchaseIndirect: boolean;
//   indPurchasedStockSale: boolean;
//   netIndirectExpenses: boolean;
//   [key: string]: any;
// };

// type MutualPeriod = { id: string; dateFrom: string; dateTo: string };

// // ─── Constants ────────────────────────────────────────────────────────────────

// const STOCK_TYPES: { key: StockType; label: string; icon: string; desc: string; investmentTypes: string[] }[] = [
//   { key: 'all',       label: 'All types',   icon: '⊞', desc: 'Every investment',       investmentTypes: [] },
//   { key: 'equity',    label: 'Equity',      icon: '📈', desc: 'Listed shares & stocks', investmentTypes: ['equity'] },
//   { key: 'mutual',    label: 'Mutual fund', icon: '🔄', desc: 'Multiple NAV periods',   investmentTypes: ['mutual', 'mutual_fund'] },
//   { key: 'fno',       label: 'F&O',         icon: '📊', desc: 'Futures & options',      investmentTypes: ['fno', 'futures', 'options'] },
//   { key: 'direct',    label: 'Direct',      icon: '🏦', desc: 'Direct investments',     investmentTypes: ['direct'] },
//   { key: 'structure', label: 'Structure',   icon: '🗂️', desc: 'Structured products',    investmentTypes: ['structure'] },
// ];

// const ENTRY_TYPES: { type: EntryType; label: string; color: string; bg: string; border: string; hasLabel: boolean }[] = [
//   { type: 'Closing',    label: 'Closing stock', color: '#085041', bg: '#E1F5EE', border: '#5DCAA5', hasLabel: false },
//   { type: 'Loss',       label: 'Loss',          color: '#791F1F', bg: '#FCEBEB', border: '#F09595', hasLabel: false },
//   { type: 'Profit',     label: 'Profit',        color: '#27500A', bg: '#EAF3DE', border: '#97C459', hasLabel: false },
//   { type: 'Commission', label: 'Commission',    color: '#3C3489', bg: '#EEEDFE', border: '#AFA9EC', hasLabel: true  },
//   { type: 'Expenses',   label: 'Expenses',      color: '#633806', bg: '#FAEEDA', border: '#FAC775', hasLabel: true  },
//   { type: 'Sale',       label: 'Sale',          color: '#185FA5', bg: '#E6F1FB', border: '#85B7EB', hasLabel: false },
// ];

// const FINANCIAL_RECORDS_API = `${process.env.REACT_APP_API_URL}/auth/financial-records`;

// // ─── Helpers ──────────────────────────────────────────────────────────────────

// function parseCategoriesForDb(categories: string | StockCategoryObj[]): StockCategoryObj[] {
//   if (Array.isArray(categories)) return categories as StockCategoryObj[];
//   if (typeof categories === 'string') {
//     try {
//       const value = categories.trim();
//       if (value.startsWith('[')) {
//         const arr = JSON.parse(value);
//         if (Array.isArray(arr)) return arr;
//         return [arr];
//       }
//     } catch {}
//   }
//   return [];
// }

// function getAllCurrentAmountsFor(
//   stockId: number | string, catId: number | string,
//   records: StockCurrentAmountRecord[], dateFrom?: string, dateTo?: string
// ) {
//   if (!stockId || !catId) return [];
//   return records
//     .filter(r =>
//       String(r.stock_id) === String(stockId) &&
//       String(r.cat_id)   === String(catId) &&
//       (!dateFrom || new Date(r.current_price_date) >= new Date(dateFrom)) &&
//       (!dateTo   || new Date(r.current_price_date) <= new Date(dateTo))
//     )
//     .sort((a, b) => (a.current_price_date < b.current_price_date ? 1 : -1));
// }

// function getLatestCurrentAmountFor(
//   stockId: number | string, catId: number | string,
//   records: StockCurrentAmountRecord[], dateFrom?: string, dateTo?: string
// ) {
//   const all = getAllCurrentAmountsFor(stockId, catId, records, dateFrom, dateTo);
//   return all.length === 0 ? null : all[0];
// }

// function downloadCSV(csv: string, filename: string) {
//   const blob = new Blob([csv], { type: 'text/csv' });
//   const url  = window.URL.createObjectURL(blob);
//   const a    = document.createElement('a');
//   a.href = url; a.download = filename; a.click();
//   window.URL.revokeObjectURL(url);
// }

// function formatPeriod(dateFrom?: string, dateTo?: string) {
//   if (!dateFrom && !dateTo) return 'All dates';
//   if (dateFrom && dateTo)   return `${new Date(dateFrom).toLocaleDateString()} to ${new Date(dateTo).toLocaleDateString()}`;
//   if (dateFrom)             return `From ${new Date(dateFrom).toLocaleDateString()}`;
//   if (dateTo)               return `Up to ${new Date(dateTo).toLocaleDateString()}`;
//   return '';
// }

// function getMonthDiff(_: any, to: string | Date | undefined, parties: any[], partId: number) {
//   // Find the party in the parties array
//   //console.log("parties data,", parties);
//   const party = parties.find((p: any) => Number(p.id) === Number(partId));
//   if (!party) return 1;

//   // Gather all string dates for the party in yyyy-mm-dd format
//   let dateList: Date[] = [];
//   if (Array.isArray(party.dates) && party.dates.length > 0) {
//     // .dates exists on the party, expected as array of date strings
//     dateList = party.dates
//       .filter(Boolean)
//       .map((d: string | Date) => typeof d === "string" ? new Date(d) : d);
//   } else if (party.date) {
//     // Fallback to single date property
//     dateList = [typeof party.date === "string" ? new Date(party.date) : party.date];
//   }

//   if (dateList.length === 0) return 1;

//   // Take the earliest date (by value)
//   const earliest = dateList.reduce((min, d) => (d.getTime() < min.getTime() ? d : min), dateList[0]);
//   const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//   // If the month and year are the same, return 1
//   if (earliest.getFullYear() === end.getFullYear() && earliest.getMonth() === end.getMonth()) {
//     return 1;
//   }

//   // Calculate month difference
//   let months = (end.getFullYear() - earliest.getFullYear()) * 12 + (end.getMonth() - earliest.getMonth());
//   if (end.getDate() >= earliest.getDate()) {
//     months += 1;
//   }
//   return months < 1 ? 1 : months;
// }
// function getMonthDiff2(partyDate: string | Date | undefined, to: string | Date | undefined) {

//   if (!partyDate) return 1;
//   const start = typeof partyDate === "string" ? new Date(partyDate) : partyDate;
//   const end = to ? (typeof to === "string" ? new Date(to) : to) : new Date();

//   if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) {
//     return 1;
//   }
//   let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
//   if (end.getDate() >= start.getDate()) {
//     months += 1;
//   }
//   return months < 1 ? 1 : months;
// }
// async function fetchSellStocks() {
//   try {
//     const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`);
//     if (!res.ok) return [];
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch { return []; }
// }

// async function fetchWithdrawals(): Promise<WithdrawalRecord[]> {
//   try {
//     const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/withdrawals`);
//     if (!res.ok) return [];
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch { return []; }
// }

// async function apiFetchFinancialRecords(): Promise<FinancialEntry[]> {
//   try {
//     const res = await fetch(FINANCIAL_RECORDS_API);
//     if (!res.ok) return [];
//     const data = await res.json();
//     return Array.isArray(data) ? data : [];
//   } catch { return []; }
// }

// async function apiSaveFinancialRecord(entry: FinancialEntry): Promise<FinancialEntry | null> {
//   try {
//     const method = entry.id ? 'PUT' : 'POST';
//     const url    = entry.id ? `${FINANCIAL_RECORDS_API}/${entry.id}` : FINANCIAL_RECORDS_API;
//     const res    = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(entry) });
//     if (!res.ok) return null;
//     return await res.json();
//   } catch { return null; }
// }

// async function apiDeleteFinancialRecord(id: number): Promise<boolean> {
//   try {
//     const res = await fetch(`${FINANCIAL_RECORDS_API}/${id}`, { method: 'DELETE' });
//     return res.ok;
//   } catch { return false; }
// }

// // ─── Wizard Step Bar ──────────────────────────────────────────────────────────

// function StepBar({ current }: { current: WizardStep }) {
//   const steps = [
//     { n: 1, label: 'Investment type' },
//     { n: 2, label: 'Date range' },
//     { n: 3, label: 'Financial entries' },
//     { n: 4, label: 'Review & generate' },
//   ];
//   return (
//     <div className="flex items-center mb-8">
//       {steps.map(({ n, label }, i) => {
//         const done   = n < current;
//         const active = n === current;
//         return (
//           <React.Fragment key={n}>
//             <div className="flex flex-col items-center gap-1 min-w-[60px]">
//               <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[13px] font-semibold border-[1.5px] transition-all ${
//                 done   ? 'bg-[#1D9E75] border-[#1D9E75] text-white' :
//                 active ? 'bg-[#534AB7] border-[#534AB7] text-white' :
//                          'bg-white border-gray-200 text-gray-400'
//               }`}>
//                 {done ? <FaCheck className="text-[10px]" /> : n}
//               </div>
//               <span className={`text-[10px] whitespace-nowrap font-medium ${
//                 active ? 'text-[#534AB7]' : done ? 'text-[#1D9E75]' : 'text-gray-400'
//               }`}>{label}</span>
//             </div>
//             {i < steps.length - 1 && (
//               <div className={`flex-1 h-px mx-2 mb-4 transition-colors ${n < current ? 'bg-[#1D9E75]' : 'bg-gray-200'}`} />
//             )}
//           </React.Fragment>
//         );
//       })}
//     </div>
//   );
// }

// // ─── Step 1: Investment Type ──────────────────────────────────────────────────

// function Step1InvestmentType({
//   selected, onSelect, onNext,
// }: { selected: StockType; onSelect: (t: StockType) => void; onNext: () => void }) {
//   return (
//     <div>
//       <p className="text-[13px] text-gray-500 mb-5">
//         Select the type of investment to analyse. This controls which stocks appear in the balance sheet.
//       </p>
//       <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
//         {STOCK_TYPES.map(({ key, label, icon, desc }) => (
//           <button key={key} onClick={() => onSelect(key)}
//             className={`flex flex-col items-center gap-2 p-4 rounded-xl border-[1.5px] text-center transition-all ${
//               selected === key
//                 ? 'border-[#534AB7] bg-[#EEEDFE] shadow-sm'
//                 : 'border-gray-200 bg-white hover:border-[#7F77DD] hover:bg-[#EEEDFE]/50'
//             }`}>
//             <span className="text-2xl">{icon}</span>
//             <span className={`font-semibold text-[13px] ${selected === key ? 'text-[#534AB7]' : 'text-gray-800'}`}>{label}</span>
//             <span className="text-[11px] text-gray-400">{desc}</span>
//           </button>
//         ))}
//       </div>
//       {selected === 'mutual' && (
//         <div className="flex items-start gap-2 p-3 bg-[#E6F1FB] border border-[#85B7EB] rounded-lg text-[12px] text-[#0C447C] mb-4">
//           <span className="mt-0.5">ℹ️</span>
//           <span>Mutual fund mode lets you add <strong>multiple date periods</strong> in the next step — each period fetches NAV data independently.</span>
//         </div>
//       )}
//       <div className="flex justify-between items-center mt-2">
//         <div />
//         <button onClick={onNext}
//           className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">
//           Continue <FaChevronRight className="text-[11px]" />
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Step 2: Date Range ───────────────────────────────────────────────────────

// function Step2DateRange({
//   stockType, dateFrom, setDateFrom, dateTo, setDateTo,
//   interestDateTo, setInterestDateTo, interestRate, setInterestRate,
//   mutualPeriods, setMutualPeriods, onBack, onNext,
// }: {
//   stockType: StockType;
//   dateFrom: string; setDateFrom: (v: string) => void;
//   dateTo: string;   setDateTo:   (v: string) => void;
//   interestDateTo: string; setInterestDateTo: (v: string) => void;
//   interestRate: number;   setInterestRate:   (v: number) => void;
//   mutualPeriods: MutualPeriod[]; setMutualPeriods: (v: MutualPeriod[]) => void;
//   onBack: () => void; onNext: () => void;
// }) {
//   const isMutual = stockType === 'mutual';

//   const addPeriod = () =>
//     setMutualPeriods([...mutualPeriods, { id: Date.now().toString(), dateFrom: '', dateTo: '' }]);

//   const removePeriod = (id: string) =>
//     setMutualPeriods(mutualPeriods.filter(p => p.id !== id));

//   const updatePeriod = (id: string, field: 'dateFrom' | 'dateTo', val: string) =>
//     setMutualPeriods(mutualPeriods.map(p => p.id === id ? { ...p, [field]: val } : p));

//   return (
//     <div>
//       <p className="text-[13px] text-gray-500 mb-5">
//         {isMutual
//           ? 'Add one or more valuation periods. Each period fetches NAV independently.'
//           : 'Define the date window for your balance sheet calculations.'}
//       </p>
//       {!isMutual ? (
//         <div className="space-y-4">
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Date from</label>
//               <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Date to</label>
//               <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//           </div>
//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest calculation up to</label>
//               <input type="date" value={interestDateTo} onChange={e => setInterestDateTo(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest rate (% p.a.)</label>
//               <input type="number" value={interestRate} min={0} step={0.1}
//                 onChange={e => setInterestRate(parseFloat(e.target.value) || 0)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//           </div>
//         </div>
//       ) : (
//         <div className="space-y-3">
//           {mutualPeriods.map((period, idx) => (
//             <div key={period.id} className="border border-gray-200 rounded-xl p-4 relative bg-white">
//               <div className="text-[12px] font-semibold text-gray-500 mb-3">Period {idx + 1}</div>
//               {mutualPeriods.length > 1 && (
//                 <button onClick={() => removePeriod(period.id)}
//                   className="absolute top-3 right-3 text-gray-300 hover:text-red-400 transition text-lg leading-none">×</button>
//               )}
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className="block text-[11px] font-semibold text-gray-500 uppercase mb-1">Date from</label>
//                   <input type="date" value={period.dateFrom} onChange={e => updatePeriod(period.id, 'dateFrom', e.target.value)}
//                     className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//                 </div>
//                 <div>
//                   <label className="block text-[11px] font-semibold text-gray-500 uppercase mb-1">NAV date (to)</label>
//                   <input type="date" value={period.dateTo} onChange={e => updatePeriod(period.id, 'dateTo', e.target.value)}
//                     className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//                 </div>
//               </div>
//             </div>
//           ))}
//           <button onClick={addPeriod}
//             className="w-full py-2.5 border-2 border-dashed border-gray-200 rounded-xl text-[13px] text-gray-500 hover:border-[#534AB7] hover:text-[#534AB7] hover:bg-[#EEEDFE]/30 transition flex items-center justify-center gap-2">
//             <FaPlus className="text-[11px]" /> Add another period
//           </button>
//           <div className="grid grid-cols-2 gap-4 pt-2">
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest calculation up to</label>
//               <input type="date" value={interestDateTo} onChange={e => setInterestDateTo(e.target.value)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//             <div>
//               <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest rate (% p.a.)</label>
//               <input type="number" value={interestRate} min={0} step={0.1}
//                 onChange={e => setInterestRate(parseFloat(e.target.value) || 0)}
//                 className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//             </div>
//           </div>
//         </div>
//       )}
//       <div className="flex justify-between mt-6">
//         <button onClick={onBack}
//           className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition">
//           <FaChevronLeft className="text-[11px]" /> Back
//         </button>
//         <button onClick={onNext}
//           className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">
//           Continue <FaChevronRight className="text-[11px]" />
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Step 3: Financial Entries ────────────────────────────────────────────────

// function Step3FinancialEntries({
//   parties, financialRecords, onSaved, onBack, onNext,
// }: {
//   parties: Party[];
//   financialRecords: FinancialEntry[];
//   onSaved: () => void;
//   onBack: () => void;
//   onNext: () => void;
// }) {
//   const [selectedPartyId, setSelectedPartyId] = useState('');
//   const [activeTab,  setActiveTab]  = useState<EntryType>('Closing');
//   const [localRows,  setLocalRows]  = useState<FinancialEntry[]>([]);
//   const [saving,     setSaving]     = useState(false);
//   const [savedTabs,  setSavedTabs]  = useState<Record<string, Set<EntryType>>>({});

//   useEffect(() => {
//     if (!selectedPartyId) { setLocalRows([]); return; }
//     const existing = financialRecords.filter(
//       r => String(r.party_id) === selectedPartyId && r.record_type === activeTab
//     );
//     setLocalRows(existing.length > 0 ? existing : [makeBlankRow(selectedPartyId, activeTab)]);
//   }, [selectedPartyId, activeTab, financialRecords]);

//   function makeBlankRow(pid: string, type: EntryType): FinancialEntry {
//     return { party_id: pid, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '', units: '', stock_name: '' };
//   }

//   const addRow = () => setLocalRows(prev => [...prev, makeBlankRow(selectedPartyId, activeTab)]);

//   const updateRow = (idx: number, field: keyof FinancialEntry, val: string) => {
//     setLocalRows(prev => { const c = [...prev]; c[idx] = { ...c[idx], [field]: val }; return c; });
//   };

//   const removeRow = async (idx: number) => {
//     const row = localRows[idx];
//     if (row.id) { setSaving(true); await apiDeleteFinancialRecord(row.id); setSaving(false); onSaved(); }
//     setLocalRows(prev => prev.filter((_, i) => i !== idx));
//   };

//   const saveCurrentTab = async () => {
//     setSaving(true);
//     const validRows = localRows.filter(r => r.amount && r.date);
//     for (const row of validRows) {
//       await apiSaveFinancialRecord({ ...row, party_id: selectedPartyId, record_type: activeTab });
//     }
//     setSaving(false);
//     onSaved();
//     setSavedTabs(prev => {
//       const next = { ...prev };
//       if (!next[selectedPartyId]) next[selectedPartyId] = new Set();
//       next[selectedPartyId].add(activeTab);
//       return next;
//     });
//   };

//   const tabHasData = (type: EntryType) => {
//     if (!selectedPartyId) return false;
//     return (
//       savedTabs[selectedPartyId]?.has(type) ||
//       financialRecords.some(r => String(r.party_id) === selectedPartyId && r.record_type === type && r.amount)
//     );
//   };

//   const entryConfig = ENTRY_TYPES.find(e => e.type === activeTab)!;

//   return (
//     <div>
//       <p className="text-[13px] text-gray-500 mb-5">
//         Add manual financial entries per party. These are optional — you can skip this step if not applicable.
//       </p>
//       <div className="mb-5">
//         <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Select party</label>
//         <select value={selectedPartyId} onChange={e => setSelectedPartyId(e.target.value)}
//           className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30 bg-white">
//           <option value="">— choose a party to add entries —</option>
//           {parties.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
//         </select>
//       </div>
//       {selectedPartyId && (
//         <div>
//           <div className="flex flex-wrap gap-2 mb-4">
//             {ENTRY_TYPES.map(({ type, label, bg, border, color }) => {
//               const hasData = tabHasData(type);
//               const isActive = activeTab === type;
//               return (
//                 <button key={type} onClick={() => setActiveTab(type)}
//                   style={isActive
//                     ? { background: entryConfig.color, borderColor: entryConfig.color, color: '#fff' }
//                     : hasData
//                       ? { background: '#E1F5EE', borderColor: '#5DCAA5', color: '#085041' }
//                       : { background: '#fff', borderColor: '#D0D5DD', color: '#667085' }
//                   }
//                   className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold border transition">
//                   {hasData && <FaCheck className="text-[10px]" />}
//                   {label}
//                 </button>
//               );
//             })}
//           </div>
//           <div className="space-y-2 mb-3">
//             {localRows.map((row, idx) => (
//               <div key={idx} className="border border-gray-200 rounded-xl p-3"
//                 style={{ borderLeftColor: entryConfig.border, borderLeftWidth: 3 }}>
//                 {/* Label field for Commission and Expenses */}
//                 {entryConfig.hasLabel && (
//                   <div className="mb-3">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Label / description</label>
//                     <input type="text" value={row.label || ''}
//                       placeholder={activeTab === 'Expenses' ? 'e.g. DP charges, STT, custody fee…' : 'e.g. advisor fee Q3, PMS fee…'}
//                       onChange={e => updateRow(idx, 'label', e.target.value)}
//                       className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
//                   </div>
//                 )}
//                 {/* Stock + Units fields for Sale */}
//                 {activeTab === 'Sale' && (
//                   <div className="grid grid-cols-2 gap-3 mb-3">
//                     <div>
//                       <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Stock name</label>
//                       <input type="text" value={row.stock_name || ''} placeholder="Stock name"
//                         onChange={e => updateRow(idx, 'stock_name', e.target.value)}
//                         className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
//                     </div>
//                     <div>
//                       <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Units</label>
//                       <input type="number" value={row.units || ''} placeholder="Qty"
//                         onChange={e => updateRow(idx, 'units', e.target.value)}
//                         className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
//                     </div>
//                   </div>
//                 )}
//                 <div className="flex gap-3 items-end">
//                   <div className="flex-1">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Date</label>
//                     <input type="date" value={row.date ? row.date.slice(0, 10) : ''} onChange={e => updateRow(idx, 'date', e.target.value)}
//                       className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
//                   </div>
//                   <div className="flex-1">
//                     <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Amount (₹)</label>
//                     <input type="number" value={row.amount} placeholder="0.00"
//                       onChange={e => updateRow(idx, 'amount', e.target.value)}
//                       className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
//                   </div>
//                   <button onClick={() => removeRow(idx)}
//                     className="self-end p-2 rounded-lg border border-gray-200 text-gray-400 hover:bg-red-50 hover:border-red-200 hover:text-red-500 transition">
//                     <FaTrash className="text-[12px]" />
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="flex items-center gap-3">
//             <button onClick={addRow}
//               className="flex-1 py-2 border-2 border-dashed border-gray-200 rounded-xl text-[13px] text-gray-400 hover:border-[#534AB7] hover:text-[#534AB7] hover:bg-[#EEEDFE]/30 transition flex items-center justify-center gap-2">
//               <FaPlus className="text-[11px]" /> Add entry
//             </button>
//             <button onClick={saveCurrentTab} disabled={saving}
//               style={{ background: entryConfig.color }}
//               className="px-5 py-2 text-white rounded-xl text-[13px] font-semibold disabled:opacity-50 transition flex items-center gap-2">
//               {saving ? 'Saving…' : <><FaCheck className="text-[11px]" /> Save tab</>}
//             </button>
//           </div>
//         </div>
//       )}
//       {!selectedPartyId && (
//         <div className="flex flex-col items-center justify-center py-10 text-center text-gray-400">
//           <span className="text-4xl mb-3">📋</span>
//           <p className="text-[13px]">Select a party above to add financial entries,<br />or skip this step if not needed.</p>
//         </div>
//       )}
//       <div className="flex justify-between mt-6">
//         <button onClick={onBack}
//           className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition">
//           <FaChevronLeft className="text-[11px]" /> Back
//         </button>
//         <button onClick={onNext}
//           className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">
//           Review <FaChevronRight className="text-[11px]" />
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Step 4: Review & Generate ────────────────────────────────────────────────

// function Step4Review({
//   stockType, dateFrom, dateTo, interestRate, interestDateTo,
//   mutualPeriods, financialRecords, parties, onBack, onGenerate,
// }: {
//   stockType: StockType; dateFrom: string; dateTo: string;
//   interestRate: number; interestDateTo: string;
//   mutualPeriods: MutualPeriod[];
//   financialRecords: FinancialEntry[];
//   parties: Party[];
//   onBack: () => void; onGenerate: () => void;
// }) {
//   const typeLabel    = STOCK_TYPES.find(t => t.key === stockType)?.label || '';
//   const totalEntries = financialRecords.filter(r => r.amount).length;

//   const summaryItems = [
//     { label: 'Investment type',  value: typeLabel },
//     { label: 'Date from',        value: dateFrom ? new Date(dateFrom).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : 'All' },
//     { label: 'Date to',          value: dateTo   ? new Date(dateTo).toLocaleDateString('en-IN',   { day: '2-digit', month: 'short', year: 'numeric' }) : 'Latest' },
//     { label: 'Interest rate',    value: `${interestRate}% p.a.` },
//     ...(stockType === 'mutual' ? [{ label: 'NAV periods', value: String(mutualPeriods.length) }] : []),
//     { label: 'Financial entries', value: `${totalEntries} entr${totalEntries === 1 ? 'y' : 'ies'}` },
//   ];

//   const partyEntryMap: Record<string, number> = {};
//   financialRecords.forEach(r => {
//     if (!partyEntryMap[r.party_id]) partyEntryMap[r.party_id] = 0;
//     if (r.amount) partyEntryMap[r.party_id]++;
//   });
//   const partiesWithEntries = Object.keys(partyEntryMap).filter(pid => partyEntryMap[pid] > 0);

//   return (
//     <div>
//       <p className="text-[13px] text-gray-500 mb-5">Review your configuration before generating the balance sheet.</p>
//       <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-5">
//         {summaryItems.map(({ label, value }) => (
//           <div key={label} className="bg-gray-50 rounded-xl p-3 border border-gray-100">
//             <div className="text-[11px] text-gray-400 mb-1">{label}</div>
//             <div className="text-[14px] font-semibold text-gray-800">{value}</div>
//           </div>
//         ))}
//       </div>
//       {partiesWithEntries.length > 0 && (
//         <div className="mb-5">
//           <div className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">Parties with manual entries</div>
//           <div className="flex flex-wrap gap-2">
//             {partiesWithEntries.map(pid => {
//               const party = parties.find(p => String(p.id) === pid);
//               return (
//                 <span key={pid}
//                   className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[12px] font-semibold bg-[#E1F5EE] border border-[#5DCAA5] text-[#085041]">
//                   <FaCheck className="text-[10px]" /> {party?.name || pid} ({partyEntryMap[pid]})
//                 </span>
//               );
//             })}
//           </div>
//         </div>
//       )}
//       <div className="bg-[#EEEDFE] border border-[#AFA9EC] rounded-xl p-4 text-[13px] text-[#3C3489] mb-2">
//         <strong>Ready to generate.</strong> Click below to fetch and compute the full party balance sheet with your selected filters and entries.
//       </div>
//       <div className="flex justify-between mt-6">
//         <button onClick={onBack}
//           className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition">
//           <FaChevronLeft className="text-[11px]" /> Back
//         </button>
//         <button onClick={onGenerate}
//           className="flex items-center gap-2 px-8 py-2.5 bg-[#1D9E75] text-white rounded-lg font-semibold text-[14px] hover:bg-[#0F6E56] transition shadow-lg shadow-green-200">
//           <FaDatabase className="text-[12px]" /> Generate balance sheet
//         </button>
//       </div>
//     </div>
//   );
// }

// // ─── Inline Entry Modal (used from results table badges) ──────────────────────

// function MultiEntryForm({ type, partyId, partyName, existingRecords, onClose, onSaved }: {
//   type: EntryType; partyId: string; partyName: string;
//   existingRecords: FinancialEntry[]; onClose: () => void; onSaved: () => void;
// }) {
//   const cfg = ENTRY_TYPES.find(e => e.type === type)!;
//   const [rows,   setRows]   = useState<FinancialEntry[]>(
//     existingRecords.length > 0 ? existingRecords
//       : [{ party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '' }]
//   );
//   const [saving, setSaving] = useState(false);

//   const addRow = () =>
//     setRows(prev => [...prev, { party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '' }]);

//   const updateRow = (idx: number, field: keyof FinancialEntry, value: string) => {
//     setRows(prev => { const c = [...prev]; c[idx] = { ...c[idx], [field]: value }; return c; });
//   };

//   const removeRow = async (idx: number) => {
//     const row = rows[idx];
//     if (row.id) { setSaving(true); await apiDeleteFinancialRecord(row.id); setSaving(false); }
//     setRows(prev => prev.filter((_, i) => i !== idx));
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     for (const row of rows) {
//       if (!row.amount || !row.date) continue;
//       await apiSaveFinancialRecord({ ...row, party_id: partyId, record_type: type });
//     }
//     setSaving(false); onSaved(); onClose();
//   };

//   return (
//     <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-gray-200">
//         <div className="p-4 text-white flex justify-between items-center" style={{ background: cfg.color }}>
//           <h3 className="font-bold text-lg">{cfg.label} entries — {partyName}</h3>
//           <button onClick={onClose} className="text-2xl leading-none">&times;</button>
//         </div>
//         <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4">
//           {rows.map((entry, idx) => (
//             <div key={idx} className="border-b pb-4 last:border-0 last:pb-0">
//               {/* Label for Commission & Expenses */}
//               {cfg.hasLabel && (
//                 <div className="mb-3">
//                   <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Label / description</label>
//                   <input type="text" value={entry.label || ''}
//                     placeholder={type === 'Expenses' ? 'e.g. DP charges, STT, custody fee…' : 'e.g. advisor fee Q3, PMS fee…'}
//                     onChange={e => updateRow(idx, 'label', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
//                 </div>
//               )}
//               <div className="flex gap-3 items-end">
//                 <div className="flex-1">
//                   <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Date</label>
//                   <input type="date" value={entry.date} onChange={e => updateRow(idx, 'date', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm" />
//                 </div>
//                 <div className="flex-1">
//                   <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Amount (₹)</label>
//                   <input type="number" value={entry.amount} placeholder="0.00"
//                     onChange={e => updateRow(idx, 'amount', e.target.value)}
//                     className="w-full border rounded-lg p-2 text-sm" />
//                 </div>
//                 <button onClick={() => removeRow(idx)} className="text-red-500 p-2 pb-3 hover:text-red-700">🗑️</button>
//               </div>
//             </div>
//           ))}
//           <button onClick={addRow}
//             className="w-full py-2 border-2 border-dashed rounded-lg font-bold hover:opacity-80 transition text-sm"
//             style={{ borderColor: cfg.border, color: cfg.color }}>
//             + Add another entry
//           </button>
//         </div>
//         <div className="p-4 bg-gray-50 flex gap-3 justify-end border-t">
//           <button onClick={onClose} className="px-4 py-2 text-gray-600 font-semibold">Cancel</button>
//           <button onClick={handleSave} disabled={saving}
//             className="px-6 py-2 text-white rounded-lg font-bold shadow-lg disabled:opacity-60"
//             style={{ background: cfg.color }}>
//             {saving ? 'Saving…' : 'Save all'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Main Component ───────────────────────────────────────────────────────────

// function UnifiedBalanceSheet() {
//   // ── Wizard state ──────────────────────────────────────────────────────────
//   const [wizardStep, setWizardStep] = useState<WizardStep>(1);
//   const [wizardDone, setWizardDone] = useState(false);

//   const [selectedStockType,   setSelectedStockType]   = useState<StockType>('all');
//   const [wizardDateFrom,      setWizardDateFrom]      = useState('');
//   const [wizardDateTo,        setWizardDateTo]        = useState('');
//   const [dateFrom,            setDateFrom]            = useState('');
//   const [dateTo,              setDateTo]              = useState('');
//   const [interestDateTo,      setInterestDateTo]      = useState('');
//   const [interestPercentage,  setInterestPercentage]  = useState(3);
//   const [mutualPeriods,       setMutualPeriods]       = useState<MutualPeriod[]>([{ id: '1', dateFrom: '', dateTo: '' }]);

//   // ── Core data ─────────────────────────────────────────────────────────────
//   const [parties,           setParties]           = useState<Party[]>([]);
//   const [stocks,            setStocks]            = useState<PartyStockDBType[]>([]);
//   const [updates,           setUpdates]           = useState<StockCurrentAmountRecord[]>([]);
//   const [sellStocks,        setSellStocks]        = useState<SellStockRecord[]>([]);
//   const [withdrawals,       setWithdrawals]       = useState<WithdrawalRecord[]>([]);
//   const [financialRecords,  setFinancialRecords]  = useState<FinancialEntry[]>([]);
//   const [indexPriceHistory, setIndexPriceHistory] = useState<IndexPriceRecord[]>([]);
//   const [farmForm,          setFarmForm]          = useState({ name: '', email: '', phone: '', address: '' });
//   const [calculationFormulasConfig, setCalculationFormulasConfig] = useState<CalculationFormulaConfig | null>(null);

//   // ── Table / modal state ───────────────────────────────────────────────────
//   const [search,             setSearch]             = useState('');
//   const [page,               setPage]               = useState(1);
//   const perPage = 10;
//   const [filters,            setFilters]            = useState<Record<string, string | null>>({});
//   const [uniqueColumnValues, setUniqueColumnValues] = useState<Record<string, string[]>>({});
//   const [showFilterPanel,    setShowFilterPanel]    = useState(false);
//   const [openFilterDropdown, setOpenFilterDropdown] = useState<string | null>(null);
//   const [selectedParty,      setSelectedParty]      = useState<Party | null>(null);
//   const [showPartyModal,     setShowPartyModal]     = useState(false);
//   const [partyModalSheet,    setPartyModalSheet]    = useState<ModalSheetView>('overall');
//   const [globalQTLY,         setGlobalQtly]         = useState(false);
//   const [partyClosingAmounts,setPartyClosingAmounts]= useState<Record<string, number>>({});
//   const [entryModal, setEntryModal] = useState<{
//     isOpen: boolean; type: FinancialEntry['record_type']; partyId: string;
//   }>({ isOpen: false, type: 'Closing', partyId: '' });

//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const location = useLocation();
//   const [partyIdFromUrl, setPartyIdFromUrl] = useState<string | null>(null);

//   // ── URL party ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const sp  = new URLSearchParams(location.search);
//     let pid   = sp.get('party');
//     if (!pid) { const m = location.pathname.match(/\/(\d+)$/); if (m) pid = m[1]; }
//     setPartyIdFromUrl(pid);
//   }, [location]);

//   // ── Calculation formula config ────────────────────────────────────────────
//   useEffect(() => {
//     try {
//       const raw = localStorage.getItem('calculationsFormulasConfigV1');
//       if (raw) setCalculationFormulasConfig(JSON.parse(raw));
//     } catch {}
//   }, []);

//   // ── Settings API ──────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetch_ = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/setting`);
//         const arr = Array.isArray(res.data) ? res.data : [];
//         const farm = arr.find((i: any) => i.meta_key === 'farm');
//         if (farm) {
//           const v = typeof farm.meta_value === 'string' ? JSON.parse(farm.meta_value || '{}') : farm.meta_value || {};
//           setFarmForm({ name: v.name || '', email: v.email || '', phone: v.phone || '', address: v.address || '' });
//         }
//         const hist = arr.find((i: any) => i.meta_key === 'index_prices_history');
//         if (hist) {
//           const h = typeof hist.meta_value === 'string' ? JSON.parse(hist.meta_value || '[]') : hist.meta_value || [];
//           if (Array.isArray(h)) setIndexPriceHistory(h.sort((a: any, b: any) => (b.date > a.date ? 1 : -1)));
//         }
//       } catch {}
//     };
//     fetch_();
//   }, []);

//   useEffect(() => {
//     const load = async () => {
//       try {
//         const res = await settingapi();
//         if (Array.isArray(res)) {
//           const p = res.find((i: any) => i.meta_key === 'percentage');
//           if (p && !isNaN(parseFloat(p.meta_value))) setInterestPercentage(parseFloat(p.meta_value));
//         }
//       } catch {}
//     };
//     load();
//   }, []);

//   // ── Parties ───────────────────────────────────────────────────────────────
//   useEffect(() => {
//     async function fetchPartiesApi() {
//       try {
//         const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addparty`);
//         if (!res.ok) return;
//         const data = await res.json();
//         if (Array.isArray(data)) {
//           setParties(data.map((item: any) => ({
//             ...item,
//             categories: Array.isArray(item.categories)
//               ? item.categories
//               : typeof item.categories === 'string'
//                 ? (item.categories.trim().startsWith('[')
//                     ? JSON.parse(item.categories)
//                     : item.categories.split(',').map((c: string) => c.trim()))
//                 : [],
//           })));
//         }
//       } catch {}
//     }
//     fetchPartiesApi();
//   }, []);

//   const fetchStocksData = useCallback(async () => {
//     try { const res = await stocksData(); setStocks(Array.isArray(res) ? res : []); } catch { setStocks([]); }
//   }, []);
//   const fetchUpdatesData = useCallback(async () => {
//     try { const data = await updatestocksApi(); setUpdates(Array.isArray(data) ? data : []); } catch { setUpdates([]); }
//   }, []);

//   useEffect(() => { fetchStocksData(); fetchUpdatesData(); }, [fetchStocksData, fetchUpdatesData]);
//   useEffect(() => { (async () => setSellStocks(await fetchSellStocks()))(); }, []);
//   useEffect(() => {
//     (async () => {
//       const arr = await fetchWithdrawals();
//       setWithdrawals((arr || []).map(wd => {
//         let categories: any[] = [];
//         if (wd.catrgories) {
//           try {
//             const a = JSON.parse(wd.catrgories);
//             if (Array.isArray(a) && a.length > 0 && typeof a[0] === 'string') {
//               categories = JSON.parse(a[0]);
//               if (!Array.isArray(categories)) categories = [categories];
//             }
//           } catch {}
//         }
//         return { ...wd, categories };
//       }));
//     })();
//   }, []);

//   const loadFinancialRecords = useCallback(async () => {
//     const data = await apiFetchFinancialRecords();
//     setFinancialRecords(data);
//   }, []);
//   useEffect(() => { loadFinancialRecords(); }, [loadFinancialRecords]);

//   // ── Wizard apply ──────────────────────────────────────────────────────────
//   const generateBalanceSheet = () => {
//     setDateFrom(wizardDateFrom);
//     setDateTo(wizardDateTo);
//     setWizardDone(true);
//     setPage(1);
//   };

//   const resetWizard = () => {
//     setWizardDone(false);
//     setWizardStep(1);
//   };

//   // ── Helpers ───────────────────────────────────────────────────────────────
//   const isInDateRange = (dateStr: string) => {
//     if (!dateStr) return true;
//     const date = new Date(dateStr);
//     const from = dateFrom ? new Date(dateFrom) : null;
//     const to   = dateTo   ? new Date(dateTo)   : null;
//     if (from && date < from) return false;
//     if (to   && date > to)   return false;
//     return true;
//   };

//   const getFilteredRecords = useCallback(
//     (partyId: string, type: FinancialEntry['record_type'], from?: string, to?: string): FinancialEntry[] =>
//       financialRecords.filter(r => {
//         if (String(r.party_id) !== String(partyId)) return false;
//         if (r.record_type !== type) return false;
//         if (from && new Date(r.date) < new Date(from)) return false;
//         if (to   && new Date(r.date) > new Date(to))   return false;
//         return true;
//       }),
//     [financialRecords]
//   );

//   const sumRecords = (records: FinancialEntry[]) =>
//     records.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);

//   // ── Sundry creditors map ──────────────────────────────────────────────────
//   const partySundryCreditorsMap = React.useMemo(() => {
//     if (!updates.length || !stocks.length) return {};
//     const stockIdToParty = new Map<string, any>();
//     for (const stk of stocks) stockIdToParty.set(String(stk.id), stk.party_id);
//     const partyTotals: Record<string, number> = {};
//     for (const update of updates) {
//       const party_id = stockIdToParty.get(String(update.stock_id));
//       if (!party_id) continue;
//       const inDate = !update.current_price_date || (
//         (!dateFrom || new Date(update.current_price_date) >= new Date(dateFrom)) &&
//         (!dateTo   || new Date(update.current_price_date) <= new Date(dateTo))
//       );
//       if (!inDate) continue;
//       if (typeof update.sundry_creditors !== 'undefined' && !isNaN(Number(update.sundry_creditors))) {
//         if (!partyTotals[party_id]) partyTotals[party_id] = 0;
//         partyTotals[party_id] += Number(update.sundry_creditors);
//       }
//     }
//     return partyTotals;
//   }, [updates, stocks, dateFrom, dateTo]);

//   // ── Party aggregated rows ─────────────────────────────────────────────────
//   const partyAggregatedRows = React.useMemo(() => {
//     if (!parties.length || !stocks.length) return [];
//     const result: any[] = [];
//     for (const party of parties) {
//       const partyStocks = stocks.filter(stk => String(stk.party_id) === String(party.id));
//       let total_purchased = 0, total_used = 0, total_earning = 0, total_indirect_charges = 0;
//       const end    = dateTo ? new Date(dateTo) : new Date();
//       const months = getMonthDiff2(party.date, end);
//       const total_interest = Number(party.total_amount || 0) * (Number(interestPercentage) / 100) * Number(months);

//       const filteredSells = sellStocks.filter(s =>
//         String(s.party_id) === String(party.id) &&
//         (!dateFrom || new Date(s.date) >= new Date(dateFrom)) &&
//         (!dateTo   || new Date(s.date) <= new Date(dateTo))
//       );
//       const total_sales_amount = filteredSells.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
//       const total_sales_units  = filteredSells.reduce((sum, s) => sum + (parseFloat(s.sell_units)  || 0), 0);

//       const filteredWD = withdrawals.filter(w =>
//         String(w.party_id) === String(party.id) &&
//         (!dateFrom || new Date(w.date) >= new Date(dateFrom)) &&
//         (!dateTo   || new Date(w.date) <= new Date(dateTo))
//       );
//       const total_withdrawal_amount = filteredWD.reduce((sum, w) => sum + (parseFloat(String(w.amount)) || 0), 0);

//       const stock_aggregate: any[] = [];
//       for (const stk of partyStocks) {
//         const allCats = parseCategoriesForDb(stk.categories);
//         const cats = selectedStockType === 'all' ? allCats : allCats.filter(cat => {
//           const typeConfig = STOCK_TYPES.find(t => t.key === selectedStockType);
//           return typeConfig?.investmentTypes.includes(cat.investment_type);
//         });

//         for (const catObj of cats) {
//           const catId           = catObj.id ?? '';
//           const stock_name      = catObj.stock_name;
//           const indirectCharges = Number(catObj.indirect_charges || 0);
//           const perUnitCharge   = Number(catObj.perUnitCharge || 0);
//           const allHistory      = getAllCurrentAmountsFor(stk.id, catId, updates, dateFrom, dateTo);
//           const chronHistory    = [...allHistory].sort((a, b) => (a.current_price_date > b.current_price_date ? 1 : -1));
//           const opening         = Number(catObj.total_amount || 0);
//           const purchaseDate    = stk.date_of_purchase || stk.date || '';
//           const inDate          = isInDateRange(purchaseDate);
//           const records: any[]  = [];

//           if (inDate) {
//             records.push({
//               category: catObj.category, unit: catObj.unit, date_of_purchase: purchaseDate,
//               opening_balance: opening, update_history: [], total_purchased: opening,
//               total_used: 0, total_earning: 0, indirect_charges: indirectCharges,
//               per_unit_charge: perUnitCharge, total_profit_and_loss: 0,
//             });
//           }

//           let totalStockUsed = 0, totalStockEarning = 0, total_profit_and_loss = 0;
//           const update_history: any[] = [];
//           let prevAmount = opening;

//           for (const rec of chronHistory) {
//             const thisAmount    = Number(rec.current_price || 0);
//             const used          = thisAmount - prevAmount;
//             const earning       = thisAmount - (prevAmount + indirectCharges);
//             const profitAndLoss = thisAmount - (prevAmount + indirectCharges);
//             total_profit_and_loss += profitAndLoss;
//             const entry: any = { date: rec.current_price_date, current_amount: thisAmount, used, earning, profitAndLoss };
//             if (rec.sundry_creditors !== undefined && rec.sundry_creditors !== null) {
//               entry.dividend = Number(rec.sundry_creditors);
//               entry.sundry_creditors = Number(rec.sundry_creditors);
//             }
//             update_history.push(entry);
//             totalStockUsed    += used;
//             totalStockEarning += earning;
//           }

//           if (inDate && records.length > 0) {
//             records[0].update_history        = update_history;
//             records[0].total_used            = totalStockUsed;
//             records[0].total_earning         = totalStockEarning;
//             records[0].total_profit_and_loss = total_profit_and_loss;
//           }

//           if (inDate) {
//             total_purchased += opening + indirectCharges;
//             total_indirect_charges += indirectCharges;
//           }
//           total_used    += totalStockUsed;
//           total_earning += totalStockEarning;

//           let stockEntry = stock_aggregate.find(s => s.stock_name === stock_name);
//           if (!stockEntry) stock_aggregate.push({ stock_name, records });
//           else stockEntry.records.push(...records);
//         }
//       }

//       if (stock_aggregate.length > 0) {
//         result.push({
//           party, stocks: stock_aggregate, total_purchased, total_used, total_earning,
//           total_indirect_charges, total_interest, total_sales_amount, total_sales_units,
//           total_withdrawal_amount, withdrawals_details: filteredWD,
//         });
//       }
//     }
//     return result;
//   }, [parties, stocks, updates, dateFrom, dateTo, interestPercentage, sellStocks, withdrawals, selectedStockType]);

//   useEffect(() => {
//     if (!partyAggregatedRows.length) return;
//     setUniqueColumnValues({ party_name: partyAggregatedRows.map(r => r.party.name) });
//   }, [partyAggregatedRows]);

//   // ── Reducing balance interest ─────────────────────────────────────────────
//   const calculateReducingInterest = (
//     party: Party, withdrawalsList: WithdrawalRecord[], interestRate: number, endDate: string
//   ) => {
//     const start = new Date(party.date);
//     const end   = new Date(endDate);
//     let currentPrincipal = parseFloat(String(party.total_amount || 0));
//     let totalInterest    = 0;
//     let lastDate         = new Date(start);

//     const partyWithdrawals = withdrawalsList
//       .filter(w => String(w.party_id) === String(party.id))
//       .map(w => ({ date: new Date(w.date), amount: parseFloat(String(w.amount || 0)) }))
//       .filter(w => w.date > start && w.date <= end)
//       .sort((a, b) => a.date.getTime() - b.date.getTime());

//     const totalWithdrawal = partyWithdrawals.reduce((sum, w) => sum + w.amount, 0);

//     for (const wd of partyWithdrawals) {
//       const days = Math.floor((wd.date.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24));
//       if (days > 0) totalInterest += (currentPrincipal * interestRate / 36500) * days;
//       currentPrincipal -= wd.amount;
//       lastDate = new Date(wd.date);
//     }

//     const finalDays = Math.floor((end.getTime() - lastDate.getTime()) / (1000 * 60 * 60 * 24));
//     if (finalDays > 0) totalInterest += (currentPrincipal * interestRate / 36500) * finalDays;

//     return { accumulatedInterest: totalInterest, remainingPrincipal: currentPrincipal, totalWithdrawal };
//   };

//   // ── Build final sheet data (full logic from BalanceSheet.tsx) ─────────────
//   function buildFinalSheetDataForParty(party: Party) {
//     const fmt        = (n: number) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
//     const partyIdStr = String(party.id);
//     const partyStockRow = partyAggregatedRows.find(r => r.party.id === party.id);

//     // Financial records from DB
//     const closingRecs    = getFilteredRecords(partyIdStr, 'Closing',    dateFrom, dateTo);
//     const lossRecs       = getFilteredRecords(partyIdStr, 'Loss',       dateFrom, dateTo);
//     const profitRecs     = getFilteredRecords(partyIdStr, 'Profit',     dateFrom, dateTo);
//     const commissionRecs = getFilteredRecords(partyIdStr, 'Commission', dateFrom, dateTo);
//     const expensesRecs   = getFilteredRecords(partyIdStr, 'Expenses',   dateFrom, dateTo);

//     const lossAmt         = sumRecords(lossRecs);
//     const profitAmt       = sumRecords(profitRecs);
//     const commissionAmt   = sumRecords(commissionRecs);
//     const expensesAmt     = sumRecords(expensesRecs);
//     const closingOverride = sumRecords(closingRecs);

//     const openingStock = parties.filter(p => p.id === party.id).reduce((s, p) => s + (Number(p.total_amount) || 0), 0);
//     const end    = dateTo ? new Date(dateTo) : new Date();
//     const months =  getMonthDiff(party.date, end, stocks, party.id);
//     const interestExpenses = (Number(party.total_amount || 0)) / 2 * (Number(interestPercentage) / 100) * Number(months);

//     let sharesPurchased = 0, directExpenses = 0, purchases = 0;
//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || '';
//       if (!isInDateRange(purchaseDate)) continue;
//       parseCategoriesForDb(stk.categories).forEach(catObj => {
//         purchases += Number(catObj.total_amount || 0);
//         if (catObj.investment_type === 'structure') {
//           sharesPurchased += Number(catObj.total_amount || 0) + Number(catObj.indirect_charges || 0);
//         }
//         if (catObj.investment_type === 'direct') {
//           directExpenses += Number(catObj.total_amount || 0);
//         }
//       });
//     }

//     if (!calculationFormulasConfig?.purchaseShare && calculationFormulasConfig?.purchaseShare != undefined) sharesPurchased = 0;

//     let totalSales = 0, totalsoldstockpurchasingamount = 0;
//     let totalsoldstockpurchasingamountindirectcharges  = 0;
//     let totalsoldstocksellingpriceindirectcharges       = 0;
//     let totalHoldingCost = 0;

//     for (const stk of partyStocksRaw) {
//       const purchaseDate = stk.date_of_purchase || stk.date || '';
//       if (!isInDateRange(purchaseDate)) continue;
//       parseCategoriesForDb(stk.categories).forEach(catObj => {
//         const pUnits       = parseFloat(catObj.unit) || 0;
//         const origAmt      = Number(catObj.total_amount || 0);
//         const origIndirect = Number(catObj.indirect_charges || 0);
//         const origPPU      = pUnits > 0 ? origAmt / pUnits : 0;
//         let currentPAmt    = origAmt;
//         const latestUpdate = getLatestCurrentAmountFor(stk.id, catObj.id, updates, dateFrom, dateTo);
//         if (latestUpdate) currentPAmt = Number(latestUpdate.current_price);
//         const currentPPU = pUnits > 0 ? (currentPAmt + origIndirect) / pUnits : 0;

//         const specificSales = sellStocks.filter(s =>
//           String(s.party_id) === String(party.id) && s.stock_name === catObj.stock_name
//         );
//         const soldUnits  = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_units)       || 0), 0);
//         const soldAmount = specificSales.reduce((sum, s) => sum + (parseFloat(s.sell_amount)      || 0), 0);
//         const soldCharges = specificSales.reduce((sum, s) => sum + (parseFloat(s.indirect_charges) || 0), 0);

//         totalSales += soldAmount;
//         totalsoldstocksellingpriceindirectcharges += soldCharges;
//         if (soldUnits > 0) {
//           totalsoldstockpurchasingamount += soldUnits * origPPU;
//           totalsoldstockpurchasingamountindirectcharges += origIndirect;
//         }
//         const remainingUnits = pUnits - soldUnits;
//         if (remainingUnits > 0) totalHoldingCost += remainingUnits * currentPPU;
//       });
//     }

//     let dynamic_totalSales = totalSales;
//     let dynamic_total_sold_stock_purchasing_amount = totalsoldstockpurchasingamount;
//     if (calculationFormulasConfig?.grossSaleCharges) {
//       dynamic_totalSales -= totalsoldstocksellingpriceindirectcharges;
//       dynamic_total_sold_stock_purchasing_amount += totalsoldstockpurchasingamountindirectcharges;
//     }
//      console.log("dynamic_totalSales",dynamic_totalSales);
//      console.log("dynamic_total_sold_stock_purchasing_amount",dynamic_total_sold_stock_purchasing_amount);
//     let grossProfit = (dynamic_totalSales) - (dynamic_total_sold_stock_purchasing_amount);
//     if (calculationFormulasConfig?.grossInterestCharges) grossProfit -= interestExpenses;
//     console.log("closingOverride", closingOverride);
//     console.log("totalHoldingCost", totalHoldingCost);
//     const indirectIncome = partySundryCreditorsMap[partyIdStr] || 0;
//     const profitcs = Number(closingOverride) > 0 ? (Number(closingOverride) - Number(totalHoldingCost)) : (0 - Number(totalHoldingCost));
//     let netLoss          = grossProfit + profitcs;
//     console.log("profitcs", profitcs);
//     console.log("grossProfit", grossProfit);
//     console.log("netLoss", netLoss);
    

//     // Override with saved loss/profit
//     let netLossOverrideVal: number;
//     if (typeof lossAmt === "number" && lossAmt > 0 && (!profitAmt || profitAmt === 0)) {
//       netLossOverrideVal = -1 * lossAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && (!lossAmt || lossAmt === 0)) {
//       netLossOverrideVal = profitAmt;
//     } else if (typeof profitAmt === "number" && profitAmt > 0 && typeof lossAmt === "number" && lossAmt > 0) {
//       netLossOverrideVal = profitAmt - lossAmt;
//     } else {
//       netLossOverrideVal = netLoss;
//     }
//     let netGrossFitOverrideVal = netLossOverrideVal;

//     if (netLoss > 0) netLoss -= commissionAmt;

//     const reducingBalanceData = calculateReducingInterest(
//       party, withdrawals, interestPercentage * 12, interestDateTo || new Date().toISOString()
//     );

//     purchases += totalSales;
//     const withdrawalAmt = partyStockRow?.total_withdrawal_amount || 0;
//     const remainingAmount = (
//       (Number(party.total_amount) - sharesPurchased - interestExpenses) + indirectIncome +
//       (totalSales - totalsoldstocksellingpriceindirectcharges) - withdrawalAmt
//     );
//     // Log every variable used in `remainingAmount` calculation
//     // console.log("party.total_amount", party.total_amount);
//     // console.log("sharesPurchased", sharesPurchased);
//     // console.log("interestExpenses", interestExpenses);
//     // console.log("indirectIncome", indirectIncome);
//     // console.log("totalSales", totalSales);
//     // console.log("totalsoldstocksellingpriceindirectcharges", totalsoldstocksellingpriceindirectcharges);
//     // console.log("withdrawalAmt", withdrawalAmt);

//     let dynamic_total_indirect_expenses = 0;
//     if (calculationFormulasConfig?.indInterestCharges)    dynamic_total_indirect_expenses += interestExpenses;
//     if (calculationFormulasConfig?.indPurchaseIndirect)   dynamic_total_indirect_expenses += totalsoldstockpurchasingamountindirectcharges;
//     if (calculationFormulasConfig?.indPurchasedStockSale) dynamic_total_indirect_expenses += totalsoldstocksellingpriceindirectcharges;

//     return {
//       openingStock:  fmt(openingStock),
//       CapitalAccount: fmt((openingStock - reducingBalanceData.totalWithdrawal) + reducingBalanceData.accumulatedInterest),
//       remainingAmount: fmt(remainingAmount),
//       holdingamt:  fmt(totalHoldingCost),
//       totalWithdrawalAmount: fmt(withdrawalAmt),
//       purchases:   fmt(purchases),
//       sales:       fmt(totalSales),
//       closingStock: fmt(totalSales + netGrossFitOverrideVal),
//       grossProfit: fmt(netGrossFitOverrideVal),
//       indirectExpenses: fmt(dynamic_total_indirect_expenses),
//       interestExpenses: fmt(reducingBalanceData.accumulatedInterest + expensesAmt),
//       indirectIncome:   fmt(indirectIncome),
//       netLoss:     fmt(netLossOverrideVal),
//       salesindirectcharges: fmt(totalsoldstocksellingpriceindirectcharges),
//       purchasetosellindirectcharges: fmt(totalsoldstockpurchasingamountindirectcharges),
//       leftTotalTrading:  fmt(purchases + Math.max(grossProfit, 0)),
//       rightTotalTrading: fmt(totalSales + (closingOverride || totalHoldingCost)),
//       leftTotalPL:  fmt(openingStock + netLossOverrideVal),
//       rightTotalPL: fmt(openingStock + netLossOverrideVal),
//       directExpenses:  fmt(directExpenses),
//       sharesPurchased: fmt(sharesPurchased),
//       pnltotalcharges: fmt(dynamic_total_indirect_expenses),
//       purchaseAccount: fmt(sharesPurchased + directExpenses),
//       expenseEntries:  expensesRecs,
//       commissionEntries: commissionRecs,
//       raw: {
//         openingStock, purchases, sales: totalSales,
//         closingStock: totalSales + netGrossFitOverrideVal,
//         grossProfit: netGrossFitOverrideVal,
//         indirectExpenses: dynamic_total_indirect_expenses,
//         indirectIncome, netLoss: netLossOverrideVal,
//       },
//     };
//   }

//   // ── Balance sheet details ─────────────────────────────────────────────────
//   function buildBalanceSheetDetailsForParty(party: Party) {
//     const parseNumeric = (val: any) => {
//       if (typeof val === 'string') return Number(val.replace(/,/g, '').replace(/[^0-9.-]+/g, '')) || 0;
//       return Number(val) || 0;
//     };
//     const pnl        = buildFinalSheetDataForParty(party);
//     const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
//     let indirectcharges  = 0;
//     for (const stk of partyStocksRaw) {
//       if (!isInDateRange(stk.date_of_purchase || stk.date || '')) continue;
//       parseCategoriesForDb(stk.categories).forEach(c => { indirectcharges += Number(c.indirect_charges || 0); });
//     }
//     const interestOnCap       = pnl.interestExpenses;
//     const nestLossNumeric     = parseNumeric(pnl.netLoss);
//     const interestExpNumeric  = parseNumeric(pnl.interestExpenses);
//     const profitAndLoss       = nestLossNumeric - interestExpNumeric;
//     const numericCapitalAccount = parseNumeric(pnl.CapitalAccount);
//     const beforeInt           = numericCapitalAccount - interestExpNumeric;

//     return {
//       liabilities: [
//         { label: <b>Capital Account</b>, amount: parseNumeric(interestOnCap) + parseNumeric(beforeInt) },
   
//         {
//           label: (
//             <span style={{ paddingLeft: 12, display: 'inline-block', minWidth: 160 }}>
//               Interest on capital<br />{party.display_name}
//             </span>
//           ),
//           amount: interestOnCap,
//         },
//         {
//           label: <span style={{ paddingLeft: 8, display: 'inline-block', minWidth: 160 }}></span>,
//           amount: beforeInt,
//         },
       
//         null,
//         { label: <b>Current Liabilities</b>, amount: '' },
//         { label: <span style={{ fontSize: '12px' }}>Indirect charges</span>, amount: indirectcharges },
//         null,
//         { label: <b>TOTAL</b>, amount: pnl.CapitalAccount },
//       ],
//       assets: [
//         { label: <b>Current Assets</b>, amount: '' },
//         { label: 'Closing Stocks',  amount: partyClosingAmounts[String(party.id)] !== undefined ? partyClosingAmounts[String(party.id)] : '' },
//         { label: 'Sundry Debtors',  amount: String(pnl.remainingAmount || 0) },
//         null,
//         { label: <b>Profit &amp; Loss A/c</b>, amount: '' },
//         { label: '', amount: profitAndLoss },
//         null,
//         { label: <b>TOTAL</b>, amount: pnl.CapitalAccount },
//       ],
//     };
//   }

//   // ── P&L modal content ─────────────────────────────────────────────────────
//   function renderPnLModalContent(party: Party) {
//     const data = buildFinalSheetDataForParty(party);
//     const periodLabel = (dateFrom || dateTo)
//       ? `${dateFrom ? new Date(dateFrom).toLocaleDateString('en-GB') : ''}${dateFrom && dateTo ? ' to ' : dateTo ? 'to ' : ''}${dateTo ? new Date(dateTo).toLocaleDateString('en-GB') : ''}`
//       : 'Select date range';
//     const fmt = (n: any) =>
//       typeof n === "number"
//         ? `₹${n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
//         : n || '';
//     const renderCell = (children: React.ReactNode, { bold, align = 'left', style = {}, colSpan }: any = {}) => (
//       <td
//         style={{
//           border: '0px solid #333',
//           padding: '7px 8px',
//           fontWeight: bold ? 700 : undefined,
//           textAlign: align,
//           fontSize: 15,
//           ...style,
//         }}
//         colSpan={colSpan}
//       >
//         {children}
//       </td>
//     );
//     function addvalue(a: string, b: string) {
//       return (
//         Number(a?.toString().replace(/,/g, '') || '0') +
//         Number(b?.toString().replace(/,/g, '') || '0')
//       );
//     }

//     const netLossVal = parseFloat(String(data.netLoss).replace(/,/g, '')) || 0;
//     const interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, '')) || 0;
//     const netResult = netLossVal - interestExpVal;

//     // -- Match BalanceSheet.tsx totals row logic (see context lines 2622–2672) --
//     // @BalanceSheet.tsx (2623-2639): "Totals" rows logic applies special cases if partyClosingAmounts is set.
//     const showDirectClosingAmount = partyClosingAmounts && partyClosingAmounts[String(party.id)] !== undefined;

//     // Compute result cells as in reference
//     const totalLeft = showDirectClosingAmount
//       ? fmt(netLossVal - interestExpVal)
//       : fmt(data.leftTotalPL);

//     const totalRight = showDirectClosingAmount
//       ? fmt(netLossVal - interestExpVal)
//       : fmt(data.rightTotalPL);

//     const totalLabel = showDirectClosingAmount ? (
//       <>
//         Direct Closing Amount
//         <span className="ml-2 text-xs text-[#1CAC70] font-bold hidden">
//           {Number(partyClosingAmounts[String(party.id)]).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
//         </span>
//       </>
//     ) : (
//       <span style={{ fontWeight: 700 }}>Total</span>
//     );

//     const rows: any[] = [
//       ['', '', 'Sales Accounts', fmt(data.sales)],
//       ['Purchase Accounts', fmt(data.sharesPurchased), 'Closing Stock', fmt(partyClosingAmounts[String(party.id)])],
//       calculationFormulasConfig?.purchaseShare
//         ? [<span style={{ marginLeft: 12 }}>Shares Purchased</span>, fmt(data.sharesPurchased), '', '']
//         : [],
//       calculationFormulasConfig?.purchaseDirect
//         ? [<span style={{ marginLeft: 12 }}>Direct Purchased</span>, fmt(data.directExpenses), '', '']
//         : [],
//       [
//         <span style={{ fontWeight: 600 }}>
//           Gross Profit b/f
//           <p className="text-[8px]">This include indirect expenses</p>
//         </span>,
//         fmt(data.netLoss),
//         <span style={{ fontWeight: 600 }}>Gross Profit c/o</span>,
//         <span style={{ fontWeight: 600 }}>
//           {fmt(data.netLoss)}
//           <br />
//           {fmt(addvalue(data.sharesPurchased, data.directExpenses))}
//         </span>,
//       ],
//       [
//         <span style={{ fontWeight: 600 }}>Indirect Expenses</span>,
//         fmt(data.interestExpenses),
//         <span style={{ fontWeight: 600 }}>Indirect Incomes</span>,
//         fmt(data.indirectIncome),
//       ],
//       // Expense sub-rows (with label if present)
//       ...((data.expenseEntries || []).map((entry: FinancialEntry) => [
//         <span style={{ paddingLeft: 22, fontSize: '12px', color: '#555' }}>
//           {entry.label || 'Expense'}
//           <span style={{ marginLeft: 8, color: '#aaa', fontSize: '11px' }}>
//             {entry.date
//               ? new Date(entry.date).toLocaleDateString('en-IN', {
//                   day: '2-digit',
//                   month: 'short',
//                   year: 'numeric',
//                 })
//               : ''}
//           </span>
//         </span>,
//         <span style={{ fontSize: '12px' }}>{fmt(Number(entry.amount) || 0)}</span>,
//         <span />,
//         <span />,
//         { className: '' },
//       ])),
//       // Commission sub-rows (with label if present)
//       ...((data.commissionEntries || []).map((entry: FinancialEntry) => [
//         <span style={{ paddingLeft: 22, fontSize: '12px', color: '#6742c7' }}>
//           {entry.label || 'Commission'}
//           <span style={{ marginLeft: 8, color: '#aaa', fontSize: '11px' }}>
//             {entry.date
//               ? new Date(entry.date).toLocaleDateString('en-IN', {
//                   day: '2-digit',
//                   month: 'short',
//                   year: 'numeric',
//                 })
//               : ''}
//           </span>
//         </span>,
//         <span style={{ fontSize: '12px', color: '#6742c7' }}>{fmt(Number(entry.amount) || 0)}</span>,
//         <span />,
//         <span />,
//         { className: '' },
//       ])),
//       calculationFormulasConfig?.indInterestCharges
//         ? [
//             <span style={{ paddingLeft: 22, fontSize: '12px' }}>Interest Expenses</span>,
//             <span style={{ paddingLeft: 22, fontSize: '12px' }}>{fmt(data.interestExpenses)}</span>,
//             <span style={{ fontWeight: 600 }}>
//               {netResult < 0 ? 'Net Loss: ' : 'Net Profit: '}
//             </span>,
//             <span style={{ fontWeight: 600 }}>{fmt(netResult)}</span>,
//             { className: '' },
//           ]
//         : [],
//     ];

//     return (
//       <div style={{ background: '#fff', maxWidth: 900, margin: '0 auto', padding: 12 }} id="renderpnl">
//         <h2
//           style={{
//             fontWeight: 700,
//             color: '#000',
//             textAlign: 'center',
//             fontSize: 19,
//             marginBottom: 0,
//             letterSpacing: 1,
//           }}
//         >
//           {farmForm.name}
//         </h2>
//         <div style={{ textAlign: 'center', fontSize: 15, marginBottom: 6 }}>{farmForm.address}</div>
//         <div style={{ textAlign: 'center', fontWeight: 700, fontSize: 18, margin: '0 0 2px 0' }}>
//           Profit &amp; Loss A/c
//         </div>
//         <div style={{ textAlign: 'center', fontSize: 13, marginBottom: 6 }}>{periodLabel}</div>
//         <div style={{ overflowX: 'auto', marginTop: 11 }}>
//           <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 700 }}>
//             <thead>
//               <tr style={{ border: '1px solid #0000006e', borderLeft: 'none', borderRight: 'none' }}>
//                 {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#ffff' } })}
//                 {renderCell(periodLabel, { bold: true, align: 'center', style: { background: '#ffff' } })}
//                 {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#ffff' } })}
//                 {renderCell(periodLabel, { bold: true, align: 'center', style: { background: '#ffff' } })}
//               </tr>
//             </thead>
//             <tbody>
//               {rows.map((row, i) => {
//                 if (!row || row.length === 0) return null;
//                 const trProps = row[4] && typeof row[4] === 'object' ? row[4] : {};
//                 const trClass = trProps.className || '';
//                 const isHidden = trClass === 'hidden';
//                 return (
//                   <tr key={i} className={trClass}>
//                     {renderCell(row[0], { style: {} })}
//                     {renderCell(row[1], {
//                       align: isHidden ? undefined : 'right',
//                       style: { borderRight: '1px solid black' },
//                     })}
//                     {renderCell(row[2], { style: {} })}
//                     {renderCell(row[3], {
//                       align: isHidden ? undefined : 'right',
//                       style: {},
//                     })}
//                   </tr>
//                 );
//               })}
//               {/* Totals row with reference logic for possible direct closing amounts */}
//               <tr style={{ border: "1px solid #0000006e", borderLeft: "none", borderRight: "none" }}>
//                 {renderCell(
//                   <span style={{ fontWeight: 700 }}>
//                     {totalLabel}
//                   </span>,
//                   { align: "center", style: { background: "#ffff" } }
//                 )}
//                 {renderCell(totalLeft, {
//                   bold: true,
//                   align: "right",
//                   style: { background: "#ffff", borderRight: "1px solid black" },
//                 })}
//                 {renderCell(
//                   <span style={{ fontWeight: 700 }}>
//                     {totalLabel}
//                   </span>,
//                   { align: "center", style: { background: "#ffff" } }
//                 )}
//                 {renderCell(totalRight, {
//                   bold: true,
//                   align: "right",
//                   style: { background: "#ffff" },
//                 })}
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   }

//   // ── Balance sheet modal content ───────────────────────────────────────────
//   function renderBalanceSheetModalContent(party: Party) {
//     const balance     = buildBalanceSheetDetailsForParty(party);
//     const headerLabel = dateTo ? `(As at ${new Date(dateTo).toLocaleDateString()})` : 'select date range';
//     return (
//       <div style={{ background: '#fff' }} id="balancesheet">
//         <h2 style={{ fontWeight: 700, color: '#6742c7', textAlign: 'center', fontSize: 22 }}>{farmForm.name}</h2>
//         <div style={{ textAlign: 'center', marginBottom: 8 }}>{farmForm.address}</div>
//         <h3 style={{ textAlign: 'center', fontWeight: 700, fontSize: 20, margin: '18px 0 0 0' }}>BALANCE SHEET</h3>
//         <div style={{ textAlign: 'center', color: '#666', marginBottom: 6 }}>{headerLabel}</div>
//         <div style={{ textAlign: 'center', color: '#6742c7', marginBottom: 5, fontWeight: 'bold' }}>
//           Showing data for: {formatPeriod(dateFrom, dateTo)}
//         </div>
//         <div style={{ display: 'flex', gap: 20, justifyContent: 'center', alignItems: 'flex-start' }}>
//           {([
//             { title: 'LIABILITIES', items: balance.liabilities },
//             { title: 'ASSETS',      items: balance.assets },
//           ] as const).map(({ title, items }) => (
//             <div key={title} style={{ flex: 1, minWidth: 320 }}>
//               <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 9, color: '#6742c7' }}>{title}</div>
//               <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 14 }}>
//                 <thead>
//                   <tr>
//                     <th className="border-y border-[#d0d5dd]" style={{ background: '#ffff' }}>Particulars</th>
//                     <th className="border-y border-[#d0d5dd]" style={{ background: '#ffff' }}>Amount (₹)</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {(items as any[]).map((item: any, idx: number) =>
//                     item === null ? (
//                       <tr key={idx}><td colSpan={2} style={{ border: 'none', height: '6px' }}></td></tr>
//                     ) : (
//                       <tr key={idx}>
//                         <td>{item.label}</td>
//                         <td style={{ textAlign: 'right', color: Number(item.amount) < 0 ? '#B91C1C' : undefined }}>
//                           {item.amount !== '' && item.amount !== undefined
//                             ? typeof item.amount === 'string' ? item.amount
//                               : Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                             : ''}
//                         </td>
//                       </tr>
//                     )
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           ))}
//         </div>
//       </div>
//     );
//   }

//   // ── QTLY content ──────────────────────────────────────────────────────────
//   function renderQTLYContent(partiesList: Party[]) {
//     const periods = [...indexPriceHistory].sort((a, b) => (a.date > b.date ? 1 : -1)).map(record => {
//       const d = new Date(record.date);
//       return {
//         label:  `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getFullYear()).slice(-2)}`,
//         key:    record.date,
//         sensex: record.sensexPrice || '---',
//       };
//     });
//     const fmt2 = (n: any, isPercent = false) =>
//       n == null ? '0.00' : isPercent
//         ? (typeof n === 'number' ? n.toFixed(2) : n) + '%'
//         : typeof n === 'number' ? n.toLocaleString('en-IN', { minimumFractionDigits: 2 }) : n;

//     return (
//       <div style={{ background: '#fff', maxWidth: 1200, margin: '0 auto', padding: 24 }}>
//         <div style={{ fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 15, letterSpacing: 2, textTransform: 'uppercase' }}>
//           AS ON {periods.length > 0 ? periods[periods.length - 1].label : '---'} (QTY / PRINCIPAL / %)
//         </div>
//         {partiesList.map(party => {
//           const data        = buildFinalSheetDataForParty(party);
//           const purchases2  = Number(data?.raw?.purchases    ?? 0);
//           const grossProfit = Number(data?.raw?.grossProfit   ?? 0);
//           const gpPercent   = purchases2 > 0 ? (grossProfit / purchases2) * 100 : 0;
//           const rows2 = [
//             { label: 'GROSS PROFIT (%)',                                   values: periods.map(() => gpPercent),                       isPercent: true },
//             { label: 'Less: interest charged by us',                       values: periods.map(() => -interestPercentage),             isPercent: true },
//             { label: `Our net profit after ${interestPercentage}% interest`, values: periods.map(() => gpPercent - interestPercentage), isPercent: true },
//           ];
//           return (
//             <div key={party.id} style={{ border: '1px solid #222', marginBottom: 24, borderRadius: 6, background: '#f9f9ff', overflow: 'hidden' }}>
//               <div style={{ fontWeight: 700, fontSize: 18, padding: '10px 12px', background: '#efeefe', borderBottom: '1.5px solid #d1cdf4', color: '#6742c7' }}>
//                 {farmForm.name}
//               </div>
//               <div style={{ overflowX: 'auto' }}>
//                 <table style={{ borderCollapse: 'collapse', width: '100%' }}>
//                   <thead>
//                     <tr>
//                       <th style={{ minWidth: 350, background: '#f2f2f2', border: '1px solid #aaa', textAlign: 'left', padding: '12px', fontSize: 14 }}>
//                         {`${party.name.toUpperCase()} START FROM ${new Date(party.date).toLocaleDateString('en-GB')} (Total Capital ${Number(party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })})`}
//                       </th>
//                       {periods.map(p => (
//                         <th key={p.key} style={{ minWidth: 160, background: '#e9e6fd', border: '1px solid #aaa', textAlign: 'center', padding: '8px 5px' }}>
//                           <div style={{ fontSize: '13px', fontWeight: 700 }}>{p.label}</div>
//                           <div style={{ fontSize: '11px', fontWeight: 400, color: '#555', marginTop: '2px' }}>(Sensex {p.sensex})</div>
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {rows2.map((row, ri) => (
//                       <tr key={ri}>
//                         <td style={{ padding: '10px 12px', background: '#fff', border: '1px solid #aaa', fontWeight: 600, fontSize: 14, color: '#444' }}>{row.label}</td>
//                         {row.values.map((v, vi) => (
//                           <td key={vi} style={{ textAlign: 'right', padding: '8px 10px', fontWeight: 500, fontSize: 13, background: vi % 2 === 1 ? '#f6f6fb' : '#fff', border: '1px solid #ccc' }}>
//                             {fmt2(v, row.isPercent)}
//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     );
//   }

//   // ── Print ─────────────────────────────────────────────────────────────────
//   const onPrint = (boxid: string) => {
//     const box = document.getElementById(boxid);
//     if (!box) return;
//     document.body.innerHTML = box.innerHTML;
//     window.print();
//   };

//   // ── Filter helpers ────────────────────────────────────────────────────────
//   const handleColumnFilterChange = (colKey: string, val: string | null) => {
//     setFilters(f => ({ ...f, [colKey]: val }));
//     setPage(1);
//     setOpenFilterDropdown(null);
//   };

//   const filteredData = React.useMemo(() => {
//     let arr = partyAggregatedRows;
//     if (partyIdFromUrl) arr = arr.filter(r => String(r.party.id) === String(partyIdFromUrl));
//     if (search) arr = arr.filter(r => r.party.name?.toLowerCase().includes(search.toLowerCase()));
//     Object.entries(filters).forEach(([key, value]) => {
//       if (!value) return;
//       if (key === 'party_name') arr = arr.filter(r => r.party.name?.toLowerCase() === String(value).toLowerCase());
//     });
//     return arr;
//   }, [partyAggregatedRows, search, filters, partyIdFromUrl]);

//   const totalPage = Math.ceil(filteredData.length / perPage) || 1;
//   const pageData  = filteredData.slice((page - 1) * perPage, page * perPage);

//   function handleExportCSV() {
//     const hdrs = ['Party Name', 'Contact Person', 'Contact Number', 'Total Purchased', 'Total Used', 'Total Earning'];
//     const csv  = [hdrs.join(','), ...pageData.map(row =>
//       [row.party.name, row.party.contact_person_name, row.party.contact_person_number, row.total_purchased, row.total_used, row.total_earning]
//         .map((v: any) => `"${v !== undefined && v !== null ? String(v).replace(/"/g, '""') : ''}"`).join(',')
//     )];
//     downloadCSV(csv.join('\r\n'), 'party_balance_sheet.csv');
//   }

//   // ── Escape key ────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (!showPartyModal) return;
//     const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') setShowPartyModal(false); };
//     window.addEventListener('keydown', handler);
//     return () => window.removeEventListener('keydown', handler);
//   }, [showPartyModal]);

//   // ── Party modal ───────────────────────────────────────────────────────────
//   function renderPartyModal() {
//     if (!selectedParty) return null;
//     const row = partyAggregatedRows.find(r => r.party.id === selectedParty.id);
//     if (!row) return null;
//     return (
//       <div className="fixed top-0 left-0 right-0 bottom-0 z-40 bg-black/40 flex items-center justify-center">
//         <div className="bg-white rounded-xl shadow-lg p-6 min-w-[350px] w-[96vw] max-w-5xl relative max-h-[90vh] overflow-auto">
//           <button className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-gray-600" onClick={() => setShowPartyModal(false)} title="Close">&times;</button>
//           <h2 className="text-2xl font-bold mb-2 text-[#6742c7]">{row.party.name}</h2>
//           <div className="mb-2 text-sm text-[#6742c7] font-medium flex items-center gap-2">
//             <span>Showing data for:</span>
//             <span className="bg-white px-2 rounded text-[#222]">{formatPeriod(dateFrom, dateTo)}</span>
//           </div>
//           <div className="mb-4 flex flex-wrap gap-2">
//             {(['overall', 'final', 'balance', 'QTLY Performance'] as ModalSheetView[]).map(tab => (
//               <button key={tab}
//                 className={`px-3 py-1 rounded font-semibold border text-sm ${partyModalSheet === tab ? 'bg-[#6742c7] text-white border-[#6742c7]' : 'bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]'}`}
//                 onClick={() => setPartyModalSheet(tab)}>
//                 {tab === 'final' ? 'Final (P&L)' : tab.charAt(0).toUpperCase() + tab.slice(1)}
//               </button>
//             ))}
//           </div>

//           {/* ── Overall Tab ── */}
//           {partyModalSheet === 'overall' && (
//             <>
//               <div className="mb-6 grid gap-4 md:grid-cols-3">
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#7964e7] px-5 py-4">
//                   <div className="font-medium text-[#7964e7] uppercase text-xs mb-2 tracking-widest">Contact</div>
//                   <span className="block text-gray-700 font-semibold">{row.party.contact_person_name || '-'}</span>
//                   <span className="block text-gray-500">{row.party.contact_person_number || '-'}</span>
//                 </div>
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#41c6c4] px-5 py-4">
//                   <div className="font-medium text-[#41c6c4] uppercase text-xs mb-2 tracking-widest">Opening Balance</div>
//                   <div className="text-xl font-extrabold">
//                     {row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}
//                   </div>
//                 </div>
//                 <div className="bg-white rounded-2xl shadow border-l-4 border-[#ffa629] px-5 py-4">
//                   <div className="font-medium text-[#ffa629] uppercase text-xs mb-2 tracking-widest">Summary</div>
//                   <div className="flex justify-between"><span className="text-gray-600">Purchased</span><span className="font-bold">{typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : row.total_purchased}</span></div>
//                   <div className="flex justify-between pt-2 border-t mt-2"><span className="text-gray-600">Total Sold</span><span className="font-bold">{row.total_sales_amount !== undefined ? `₹${Number(row.total_sales_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</span></div>
//                   <div className="flex justify-between"><span className="text-gray-600">Units Sold</span><span className="font-bold">{row.total_sales_units ?? '-'}</span></div>
//                 </div>
//               </div>

//               {/* Withdrawals */}
//               {row.withdrawals_details && row.withdrawals_details.length > 0 && (
//                 <div className="mb-6">
//                   <h3 className="font-extrabold text-lg text-[#e65a23] mb-3">Withdrawals</h3>
//                   <div className="overflow-x-auto border border-orange-100 rounded-2xl">
//                     <table className="w-full text-sm">
//                       <thead className="bg-orange-50">
//                         <tr>
//                           <th className="px-3 py-2 text-left text-[#e76a28]">Date</th>
//                           <th className="px-3 py-2 text-right text-[#e76a28]">Amount</th>
//                           <th className="px-3 py-2 text-left text-[#e76a28]">Category</th>
//                           <th className="px-3 py-2 text-left text-[#e76a28]">Stock</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {row.withdrawals_details.map((wd: any) => {
//                           let cats: any[] = [];
//                           if (wd.catrgories) {
//                             try {
//                               const a = JSON.parse(wd.catrgories);
//                               if (Array.isArray(a) && typeof a[0] === 'string') { cats = JSON.parse(a[0]); if (!Array.isArray(cats)) cats = [cats]; }
//                             } catch {}
//                           }
//                           return (
//                             <tr key={wd.id} className="border-t">
//                               <td className="px-3 py-2">{wd.date ? new Date(wd.date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}</td>
//                               <td className="px-3 py-2 text-right font-bold text-[#dd661a]">{wd.amount ? `₹${Number(wd.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</td>
//                               <td className="px-3 py-2">{cats.map((c: any) => c.category).join(', ') || '-'}</td>
//                               <td className="px-3 py-2">{cats.map((c: any) => c.stockName).join(', ') || '-'}</td>
//                             </tr>
//                           );
//                         })}
//                         <tr className="bg-orange-50 font-bold">
//                           <td className="px-3 py-2">Total</td>
//                           <td className="px-3 py-2 text-right text-[#e65a23]">
//                             {`₹${row.withdrawals_details.reduce((s: number, w: any) => s + (parseFloat(String(w.amount)) || 0), 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
//                           </td>
//                           <td colSpan={2} />
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}

//               {/* Stocks */}
//               <h3 className="font-bold text-[#6742c7] text-lg mb-3">Stocks (Details per Category)</h3>
//               <div className="overflow-x-auto max-h-[370px]">
//                 {row.stocks.length === 0 && (
//                   <div className="p-10 text-center text-gray-400 italic bg-white rounded-lg shadow-inner border">No stocks found for this party.</div>
//                 )}
//                 {row.stocks.map((s: any, i: number) => (
//                   <div key={i} className="mb-6 border border-[#f1ecff] rounded-xl overflow-hidden">
//                     <div className="bg-[#6742c7] px-5 py-3"><span className="font-bold text-white text-base">{s.stock_name}</span></div>
//                     <table className="w-full text-[13px]">
//                       <thead className="bg-[#ece6fa]">
//                         <tr>
//                           {['Category', 'Unit', 'Purchase Date', 'Purchase Amt', 'Indirect Charges', 'History'].map(h => (
//                             <th key={h} className="p-2 text-center text-[#6742c7] font-semibold">{h}</th>
//                           ))}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {s.records.map((rec: any, ridx: number) => (
//                           <tr key={ridx} className="border-t text-center">
//                             <td className="p-2">{rec.category}</td>
//                             <td className="p-2">{rec.unit}</td>
//                             <td className="p-2">{rec.date_of_purchase ? new Date(rec.date_of_purchase).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : '-'}</td>
//                             <td className="p-2">{`₹${Number(rec.opening_balance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
//                             <td className="p-2">{`₹${Number(rec.indirect_charges).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
//                             <td className="p-2">
//                               {rec.update_history.length === 0 ? (
//                                 <span className="text-gray-400 italic">No updates</span>
//                               ) : (
//                                 <table className="w-full text-[11px] border">
//                                   <thead className="bg-[#f8f6ff]">
//                                     <tr>{['Date', 'Amount', 'Ind. Income', 'P/L'].map(h => <th key={h} className="px-1 py-1 border-b">{h}</th>)}</tr>
//                                   </thead>
//                                   <tbody>
//                                     {rec.update_history.slice(0, 3).map((up: any, ui: number) => (
//                                       <tr key={ui} className="text-center">
//                                         <td className="px-1 py-1">{up.date ? new Date(up.date).toLocaleDateString('en-IN', { month: 'short', day: 'numeric' }) : '-'}</td>
//                                         <td className="px-1 py-1">{`₹${Number(up.current_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</td>
//                                         <td className="px-1 py-1">{up.dividend ? `₹${Number(up.dividend).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</td>
//                                         <td className={`px-1 py-1 font-semibold ${up.profitAndLoss >= 0 ? 'text-green-600' : 'text-red-500'}`}>
//                                           {`₹${Number(up.profitAndLoss).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}
//                                         </td>
//                                       </tr>
//                                     ))}
//                                   </tbody>
//                                 </table>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 ))}
//               </div>
//             </>
//           )}

//           {partyModalSheet === 'final' && (
//             <>
//               {renderPnLModalContent(row.party)}
//               <div className="flex justify-end mt-4">
//                 <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('renderpnl')}>Print/Download</button>
//               </div>
//             </>
//           )}

//           {partyModalSheet === 'balance' && (
//             <>
//               {renderBalanceSheetModalContent(row.party)}
//               <div className="flex justify-end mt-4">
//                 <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('balancesheet')}>Print/Download</button>
//               </div>
//             </>
//           )}

//           {partyModalSheet === 'QTLY Performance' && (
//             <>
//               <div id="qtlydata">{renderQTLYContent([row.party])}</div>
//               <div className="flex justify-end mt-4">
//                 <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('qtlydata')}>Print/Download</button>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     );
//   }

//   // ── Financial summary badges ───────────────────────────────────────────────
//   const FinancialSummaryBadges = ({ partyId }: { partyId: string }) => (
//     <div className="flex flex-wrap gap-1 mt-2">
//       {ENTRY_TYPES.map(({ type, label, color, bg, border }) => {
//         const recs  = getFilteredRecords(partyId, type, dateFrom, dateTo);
//         const total = sumRecords(recs);
//         return (
//           <button key={type}
//             onClick={() => setEntryModal({ isOpen: true, type, partyId })}
//             className="flex items-center gap-1 px-2 py-1 rounded-lg text-[11px] font-semibold border transition hover:opacity-80"
//             style={{ borderColor: border, color, background: bg }}
//             title={`${label}: ₹${total.toLocaleString('en-IN', { minimumFractionDigits: 2 })} — click to edit`}>
//             {label}
//             {recs.length > 0
//               ? <span className="font-bold">₹{total.toLocaleString('en-IN', { minimumFractionDigits: 0 })}</span>
//               : <span className="text-gray-400">+</span>}
//           </button>
//         );
//       })}
//     </div>
//   );

//   // ── Render ────────────────────────────────────────────────────────────────
//   return (
//     <div className="p-6 min-h-screen" style={{ background: 'linear-gradient(120deg,rgb(255,255,255) 0%,rgb(248,255,253) 100%)' }}>

//       {/* Party detail modal */}
//       {showPartyModal && renderPartyModal()}

//       {/* Entry modals */}
//       {entryModal.isOpen && entryModal.type !== 'Sale' && (
//         <MultiEntryForm
//           type={entryModal.type as EntryType}
//           partyId={entryModal.partyId}
//           partyName={parties.find(p => String(p.id) === entryModal.partyId)?.name || ''}
//           existingRecords={financialRecords.filter(r => String(r.party_id) === entryModal.partyId && r.record_type === entryModal.type)}
//           onClose={() => setEntryModal(e => ({ ...e, isOpen: false }))}
//           onSaved={loadFinancialRecords}
//         />
//       )}

//       {/* Global QTLY modal */}
//       {globalQTLY && (
//         <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
//           <div className="relative bg-white rounded-xl shadow-lg p-6 w-[96vw] max-w-5xl max-h-[90vh] overflow-auto border-2 border-[#408A71]">
//             <button className="absolute top-3 right-4 text-2xl text-gray-400" onClick={() => setGlobalQtly(false)}>&times;</button>
//             <div id="globalQtly">{renderQTLYContent(parties)}</div>
//             <div className="flex justify-end mt-4">
//               <button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded" onClick={() => onPrint('globalQtly')}>Print/Download</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══ WIZARD (shown until generated) ══════════════════════════════════ */}
//       {!wizardDone ? (
//         <div className="max-w-2xl mx-auto">
//           <div className="mb-6">
//             <h1 className="text-[26px] font-semibold text-gray-900">Party Balance Sheet</h1>
//             <p className="text-[13px] text-gray-500 mt-1">Configure your filters and entries before generating the report.</p>
//           </div>

//           <StepBar current={wizardStep} />

//           <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
//             {wizardStep === 1 && (
//               <Step1InvestmentType
//                 selected={selectedStockType}
//                 onSelect={setSelectedStockType}
//                 onNext={() => setWizardStep(2)}
//               />
//             )}
//             {wizardStep === 2 && (
//               <Step2DateRange
//                 stockType={selectedStockType}
//                 dateFrom={wizardDateFrom}       setDateFrom={setWizardDateFrom}
//                 dateTo={wizardDateTo}           setDateTo={setWizardDateTo}
//                 interestDateTo={interestDateTo} setInterestDateTo={setInterestDateTo}
//                 interestRate={interestPercentage} setInterestRate={setInterestPercentage}
//                 mutualPeriods={mutualPeriods}   setMutualPeriods={setMutualPeriods}
//                 onBack={() => setWizardStep(1)}
//                 onNext={() => setWizardStep(3)}
//               />
//             )}
//             {wizardStep === 3 && (
//               <Step3FinancialEntries
//                 parties={parties}
//                 financialRecords={financialRecords}
//                 onSaved={loadFinancialRecords}
//                 onBack={() => setWizardStep(2)}
//                 onNext={() => setWizardStep(4)}
//               />
//             )}
//             {wizardStep === 4 && (
//               <Step4Review
//                 stockType={selectedStockType}
//                 dateFrom={wizardDateFrom}
//                 dateTo={wizardDateTo}
//                 interestRate={interestPercentage}
//                 interestDateTo={interestDateTo}
//                 mutualPeriods={mutualPeriods}
//                 financialRecords={financialRecords}
//                 parties={parties}
//                 onBack={() => setWizardStep(3)}
//                 onGenerate={generateBalanceSheet}
//               />
//             )}
//           </div>
//         </div>

//       ) : (
//         /* ══ RESULTS TABLE ══════════════════════════════════════════════════ */
//         <div>
//           {/* Header */}
//           <div className="flex flex-wrap justify-between items-center gap-3 w-full mb-5">
//             <div className="flex items-center gap-3 flex-wrap">
//               <h1 className="text-[26px] font-[600]">Party Balance Sheet</h1>
//               <div className="bg-[#EEEDFE] px-3 py-1 rounded-full border border-[#AFA9EC]">
//                 <span className="text-[#534AB7] text-[12px] font-semibold">{parties.length} parties</span>
//               </div>
//               {/* Active filter chips */}
//               <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[12px] font-medium bg-[#EEEDFE] text-[#534AB7] border border-[#AFA9EC]">
//                 {STOCK_TYPES.find(t => t.key === selectedStockType)?.label}
//               </span>
//               {(dateFrom || dateTo) && (
//                 <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[12px] font-medium bg-[#EEEDFE] text-[#534AB7] border border-[#AFA9EC]">
//                   {formatPeriod(dateFrom, dateTo)}
//                 </span>
//               )}
//             </div>
//             <div className="flex gap-2 items-center flex-wrap">
//               <button onClick={resetWizard}
//                 className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#534AB7] border-[#534AB7] hover:bg-[#EEEDFE] transition">
//                 ← Change filters
//               </button>
//               <button
//                 className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#1CAC70] border-[#1CAC70] hover:bg-[#E6F8F0]"
//                 onClick={() => (window.location.href = '/mutual-balance-sheet')}>
//                 Mutual Balance Sheet
//               </button>
//               <button
//                 className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]"
//                 onClick={() => setGlobalQtly(true)}>
//                 QTLY Performance
//               </button>
//               <button
//                 className="flex items-center gap-1 border border-[#D0D5DD] bg-white py-2 px-4 rounded-lg"
//                 onClick={() => fileInputRef.current?.click()}>
//                 <BiImport /> Import
//               </button>
//               <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} />
//               <button
//                 className="flex items-center gap-1 border border-[#1CAC70] bg-[#E6F8F0] py-2 px-4 rounded-lg text-[#1CAC70] font-semibold"
//                 onClick={handleExportCSV}>
//                 Export CSV
//               </button>
//             </div>
//           </div>

//           {/* Search */}
//           <div className="flex justify-between items-center gap-3 mb-4 flex-wrap">
//             <div className="bg-white h-[38px] flex items-center rounded-lg px-2 border border-[#D0D5DD] gap-1 min-w-[280px]">
//               <CiSearch className="text-[#8488B7] text-[22px]" />
//               <input type="text" placeholder="Search party name…"
//                 className="w-full bg-transparent h-[32px] focus:outline-none text-sm"
//                 value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
//             </div>
//             <div className="text-[12px] text-gray-500">
//               Showing data for: <span className="font-semibold text-[#534AB7]">{formatPeriod(dateFrom, dateTo)}</span>
//             </div>
//           </div>

//           {/* Table */}
//           <div className="max-w-full overflow-x-auto border border-gray-200 rounded-xl shadow-sm">
//             <table className="w-full border-collapse table-auto">
//               <thead className="bg-gradient-to-r from-white to-[#EBF9F4]">
//                 <tr>
//                   <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Party name</th>
//                   <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Contact person</th>
//                   <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Contact number</th>
//                   <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Total amount</th>
//                   <th className="px-3 py-3 text-right text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Total purchased</th>
//                   <th className="px-3 py-3 text-center text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Actions &amp; entries</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {pageData.length === 0 ? (
//                   <tr>
//                     <td colSpan={6} className="text-center py-8 text-gray-400 font-semibold">No data found.</td>
//                   </tr>
//                 ) : (
//                   pageData.map(row => (
//                     <tr key={row.party.id} className="hover:bg-gray-50/50 transition align-top">
//                       <td className="px-3 py-3 text-sm font-semibold text-[#101828] border-b whitespace-nowrap">{row.party.name}</td>
//                       <td className="px-3 py-3 text-sm text-[#344054] border-b whitespace-nowrap">{row.party.contact_person_name}</td>
//                       <td className="px-3 py-3 text-sm text-[#344054] border-b whitespace-nowrap">{row.party.contact_person_number}</td>
//                       <td className="px-3 py-3 text-sm font-medium text-[#101828] border-b whitespace-nowrap">
//                         {row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}
//                       </td>
//                       <td className="px-3 py-3 text-sm font-medium text-[#344054] border-b whitespace-nowrap text-right">
//                         {typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : row.total_purchased}
//                       </td>
//                       <td className="px-3 py-3 border-b">
//                         <button
//                           onClick={() => { setSelectedParty(row.party); setShowPartyModal(true); setPartyModalSheet('overall'); }}
//                           className="flex items-center gap-1 text-[#6742C6] text-[13px] px-3 py-2 rounded-lg border border-[#dcd7ee] hover:border-[#6742C6] bg-white hover:bg-[#f6f4fd] font-medium transition">
//                           <FaEye /> View
//                         </button>
//                         {/* Financial entry badges — click to open edit modal */}
//                         <FinancialSummaryBadges partyId={String(row.party.id)} />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* Pagination */}
//           <div className="flex items-center justify-between mt-4">
//             <span className="text-[#344054] text-[14px]">Page {page} of {totalPage}</span>
//             <div className="flex gap-2">
//               <button disabled={page === 1} onClick={() => setPage(p => p - 1)}
//                 className="px-3 py-1 bg-white text-[#344054] border rounded-lg disabled:opacity-40">Previous</button>
//               <button disabled={page === totalPage || filteredData.length === 0} onClick={() => setPage(p => p + 1)}
//                 className="px-3 py-1 bg-white text-[#344054] border rounded-lg disabled:opacity-40">Next</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default UnifiedBalanceSheet;

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BiImport } from 'react-icons/bi';
import { CiSearch } from 'react-icons/ci';
import { FaEye, FaChevronRight, FaChevronLeft, FaPlus, FaTrash, FaCheck, FaDatabase } from 'react-icons/fa';
import stocksData from '../data/stock';
import updatestocksApi from '../data/stockhistory';
import settingapi from '../data/setting';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

// ─── Types ────────────────────────────────────────────────────────────────────

type StockCategoryObj = {
  id: number;
  stock_name: string;
  category: string;
  unit: string;
  total_amount: string;
  indirect_charges: string;
  perUnitCharge: string;
  investment_type: string;
};

type WithdrawalRecord = {
  id: number;
  party_id: number;
  amount: number;
  date: string;
  catrgories: string;
};

type SellStockRecord = {
  id: number;
  party_id: number;
  category: string;
  stock_id: string;
  stock_name: string;
  sell_units: string;
  sell_amount: string;
  indirect_charges: string;
  date: string;
  catrgories: string;
};

interface Party {
  id: number;
  date: string;
  name: string;
  display_name: string;
  number: string;
  contact_person_name: string;
  contact_person_number: string;
  categories: string[];
  total_amount?: number | string;
}

type PartyStockDBType = {
  id: number | string;
  party_id: number | string;
  categories: string | StockCategoryObj[];
  date?: string;
  date_of_purchase?: string;
};

type StockCurrentAmountRecord = {
  id: number;
  stock_id: number;
  cat_id: number;
  current_price: number | string;
  current_price_date: string;
  sundry_creditors?: number;
};

interface IndexPriceRecord {
  id: number;
  niftyPrice?: string;
  sensexPrice?: string;
  date: string;
}

type FinancialEntry = {
  id?: number;
  party_id: string;
  record_type: 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
  amount: string;
  date: string;
  label?: string;
  stock_name?: string;
  category?: string;
  units?: string;
};

type ModalSheetView = 'overall' | 'final' | 'balance' | 'QTLY Performance';
type StockType = 'all' | 'equity' | 'mutual' | 'fno' | 'direct' | 'structure';
type EntryType = 'Closing' | 'Loss' | 'Profit' | 'Commission' | 'Expenses' | 'Sale';
type WizardStep = 1 | 2 | 3 | 4;

type CalculationFormulaConfig = {
  purchaseShare: boolean;
  purchaseDirect: boolean;
  grossSaleCharges: boolean;
  grossInterestCharges: boolean;
  indInterestCharges: boolean;
  indPurchaseIndirect: boolean;
  indPurchasedStockSale: boolean;
  netIndirectExpenses: boolean;
  [key: string]: any;
};

type MutualPeriod = { id: string; dateFrom: string; dateTo: string };

// ─── Constants ────────────────────────────────────────────────────────────────

const STOCK_TYPES: { key: StockType; label: string; icon: string; desc: string; investmentTypes: string[] }[] = [
  { key: 'all',       label: 'All types',   icon: '⊞', desc: 'Every investment',       investmentTypes: [] },
  { key: 'equity',    label: 'Equity',      icon: '📈', desc: 'Listed shares & stocks', investmentTypes: ['equity'] },
  { key: 'mutual',    label: 'Mutual fund', icon: '🔄', desc: 'Multiple NAV periods',   investmentTypes: ['mutual', 'mutual_fund'] },
  { key: 'fno',       label: 'F&O',         icon: '📊', desc: 'Futures & options',      investmentTypes: ['fno', 'futures', 'options'] },
  { key: 'direct',    label: 'Direct',      icon: '🏦', desc: 'Direct investments',     investmentTypes: ['direct'] },
  { key: 'structure', label: 'Structure',   icon: '🗂️', desc: 'Structured products',    investmentTypes: ['structure'] },
];

const ENTRY_TYPES: { type: EntryType; label: string; color: string; bg: string; border: string; hasLabel: boolean }[] = [
  { type: 'Closing',    label: 'Closing Stock', color: '#085041', bg: '#E1F5EE', border: '#5DCAA5', hasLabel: false },
  { type: 'Loss',       label: 'Loss Amount',   color: '#791F1F', bg: '#FCEBEB', border: '#F09595', hasLabel: false },
  { type: 'Profit',     label: 'Profit Amount', color: '#27500A', bg: '#EAF3DE', border: '#97C459', hasLabel: false },
  { type: 'Commission', label: 'Commission',    color: '#3C3489', bg: '#EEEDFE', border: '#AFA9EC', hasLabel: true  },
  { type: 'Expenses',   label: 'Expenses',      color: '#633806', bg: '#FAEEDA', border: '#FAC775', hasLabel: true  },
  // { type: 'Sale',       label: 'Sale',          color: '#185FA5', bg: '#E6F1FB', border: '#85B7EB', hasLabel: false },
];

const FINANCIAL_RECORDS_API = `${process.env.REACT_APP_API_URL}/auth/financial-records`;

const WIZARD_STORAGE_KEY = 'balanceSheetWizardConfig_v1';

function loadWizardConfig() {
  try {
    const raw = localStorage.getItem(WIZARD_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function saveWizardConfig(config: object) {
  try { localStorage.setItem(WIZARD_STORAGE_KEY, JSON.stringify(config)); } catch {}
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

function parseCategoriesForDb(categories: string | StockCategoryObj[]): StockCategoryObj[] {
  if (Array.isArray(categories)) return categories as StockCategoryObj[];
  if (typeof categories === 'string') {
    try {
      const value = categories.trim();
      if (value.startsWith('[')) {
        const arr = JSON.parse(value);
        if (Array.isArray(arr)) return arr;
        return [arr];
      }
    } catch {}
  }
  return [];
}

function getAllCurrentAmountsFor(
  stockId: number | string, catId: number | string,
  records: StockCurrentAmountRecord[], dateFrom?: string, dateTo?: string
) {
  if (!stockId || !catId) return [];
  return records
    .filter(r =>
      String(r.stock_id) === String(stockId) &&
      String(r.cat_id)   === String(catId) &&
      (!dateFrom || new Date(r.current_price_date) >= new Date(dateFrom)) &&
      (!dateTo   || new Date(r.current_price_date) <= new Date(dateTo))
    )
    .sort((a, b) => (a.current_price_date < b.current_price_date ? 1 : -1));
}

function getLatestCurrentAmountFor(
  stockId: number | string, catId: number | string,
  records: StockCurrentAmountRecord[], dateFrom?: string, dateTo?: string
) {
  const all = getAllCurrentAmountsFor(stockId, catId, records, dateFrom, dateTo);
  return all.length === 0 ? null : all[0];
}

function downloadCSV(csv: string, filename: string) {
  const blob = new Blob([csv], { type: 'text/csv' });
  const url  = window.URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  window.URL.revokeObjectURL(url);
}

function formatPeriod(dateFrom?: string, dateTo?: string) {
  if (!dateFrom && !dateTo) return 'All dates';
  if (dateFrom && dateTo)   return `${new Date(dateFrom).toLocaleDateString()} to ${new Date(dateTo).toLocaleDateString()}`;
  if (dateFrom)             return `From ${new Date(dateFrom).toLocaleDateString()}`;
  if (dateTo)               return `Up to ${new Date(dateTo).toLocaleDateString()}`;
  return '';
}

// getMonthDiff using stock purchase dates (matches original BalanceSheet.tsx logic)
function getMonthDiff(_: any, to: string | Date | undefined, stocksList: any[], partId: number) {
  const stk = stocksList.find((p: any) => Number(p.party_id) === Number(partId));
  if (!stk) return 1;
  let dateList: Date[] = [];
  if (Array.isArray(stk.dates) && stk.dates.length > 0) {
    dateList = stk.dates.filter(Boolean).map((d: string | Date) => typeof d === 'string' ? new Date(d) : d);
  } else if (stk.date) {
    dateList = [typeof stk.date === 'string' ? new Date(stk.date) : stk.date];
  }
  if (dateList.length === 0) return 1;
  const earliest = dateList.reduce((min, d) => (d.getTime() < min.getTime() ? d : min), dateList[0]);
  const end = to ? (typeof to === 'string' ? new Date(to) : to) : new Date();
  if (earliest.getFullYear() === end.getFullYear() && earliest.getMonth() === end.getMonth()) return 1;
  let months = (end.getFullYear() - earliest.getFullYear()) * 12 + (end.getMonth() - earliest.getMonth());
  if (end.getDate() >= earliest.getDate()) months += 1;
  return months < 1 ? 1 : months;
}

// Simple month diff for aggregated rows
function getMonthDiff2(partyDate: string | Date | undefined, to: string | Date | undefined) {
  if (!partyDate) return 1;
  const start = typeof partyDate === 'string' ? new Date(partyDate) : partyDate;
  const end   = to ? (typeof to === 'string' ? new Date(to) : to) : new Date();
  if (start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth()) return 1;
  let months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
  if (end.getDate() >= start.getDate()) months += 1;
  return months < 1 ? 1 : months;
}

async function fetchSellStocks() {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/sellstocks`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

async function fetchWithdrawals(): Promise<WithdrawalRecord[]> {
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/withdrawals`);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

async function apiFetchFinancialRecords(): Promise<FinancialEntry[]> {
  try {
    const res = await fetch(FINANCIAL_RECORDS_API);
    if (!res.ok) return [];
    const data = await res.json();
    return Array.isArray(data) ? data : [];
  } catch { return []; }
}

async function apiSaveFinancialRecord(entry: FinancialEntry): Promise<FinancialEntry | null> {
  try {
    const method = entry.id ? 'PUT' : 'POST';
    const url    = entry.id ? `${FINANCIAL_RECORDS_API}/${entry.id}` : FINANCIAL_RECORDS_API;
    const res    = await fetch(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(entry) });
    if (!res.ok) return null;
    return await res.json();
  } catch { return null; }
}

async function apiDeleteFinancialRecord(id: number): Promise<boolean> {
  try {
    const res = await fetch(`${FINANCIAL_RECORDS_API}/${id}`, { method: 'DELETE' });
    return res.ok;
  } catch { return false; }
}

// ─── Wizard Step Bar ──────────────────────────────────────────────────────────

function StepBar({ current }: { current: WizardStep }) {
  const steps = [
    { n: 1, label: 'Investment type' },
    { n: 2, label: 'Date range' },
    { n: 3, label: 'Financial entries' },
    { n: 4, label: 'Review & generate' },
  ];
  return (
    <div className="flex items-center mb-8">
      {steps.map(({ n, label }, i) => {
        const done   = n < current;
        const active = n === current;
        return (
          <React.Fragment key={n}>
            <div className="flex flex-col items-center gap-1 min-w-[60px]">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center text-[13px] font-semibold border-[1.5px] transition-all ${
                done   ? 'bg-[#1D9E75] border-[#1D9E75] text-white' :
                active ? 'bg-[#534AB7] border-[#534AB7] text-white' :
                         'bg-white border-gray-200 text-gray-400'
              }`}>
                {done ? <FaCheck className="text-[10px]" /> : n}
              </div>
              <span className={`text-[10px] whitespace-nowrap font-medium ${
                active ? 'text-[#534AB7]' : done ? 'text-[#1D9E75]' : 'text-gray-400'
              }`}>{label}</span>
            </div>
            {i < steps.length - 1 && (
              <div className={`flex-1 h-px mx-2 mb-4 transition-colors ${n < current ? 'bg-[#1D9E75]' : 'bg-gray-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

// ─── Step 1 ───────────────────────────────────────────────────────────────────

function Step1InvestmentType({ selected, onSelect, onNext }: {
  selected: StockType; onSelect: (t: StockType) => void; onNext: () => void;
}) {
  return (
    <div>
      <p className="text-[13px] text-gray-500 mb-5">Select the type of investment to analyse.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        {STOCK_TYPES.map(({ key, label, icon, desc }) => (
          <button key={key} onClick={() => onSelect(key)}
            className={`flex flex-col items-center gap-2 p-4 rounded-xl border-[1.5px] text-center transition-all ${
              selected === key ? 'border-[#534AB7] bg-[#EEEDFE] shadow-sm' : 'border-gray-200 bg-white hover:border-[#7F77DD] hover:bg-[#EEEDFE]/50'
            }`}>
            <span className="text-2xl">{icon}</span>
            <span className={`font-semibold text-[13px] ${selected === key ? 'text-[#534AB7]' : 'text-gray-800'}`}>{label}</span>
            <span className="text-[11px] text-gray-400">{desc}</span>
          </button>
        ))}
      </div>
      {selected === 'mutual' && (
        <div className="flex items-start gap-2 p-3 bg-[#E6F1FB] border border-[#85B7EB] rounded-lg text-[12px] text-[#0C447C] mb-4">
          <span className="mt-0.5">ℹ️</span>
          <span>Mutual fund mode lets you add <strong>multiple date periods</strong> in the next step.</span>
        </div>
      )}
      <div className="flex justify-end mt-2">
        <button onClick={onNext} className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">
          Continue <FaChevronRight className="text-[11px]" />
        </button>
      </div>
    </div>
  );
}

// ─── Step 2 ───────────────────────────────────────────────────────────────────

function Step2DateRange({ stockType, dateFrom, setDateFrom, dateTo, setDateTo, interestDateTo, setInterestDateTo, interestRate, setInterestRate, mutualPeriods, setMutualPeriods, onBack, onNext }: {
  stockType: StockType; dateFrom: string; setDateFrom: (v: string) => void;
  dateTo: string; setDateTo: (v: string) => void;
  interestDateTo: string; setInterestDateTo: (v: string) => void;
  interestRate: number; setInterestRate: (v: number) => void;
  mutualPeriods: MutualPeriod[]; setMutualPeriods: (v: MutualPeriod[]) => void;
  onBack: () => void; onNext: () => void;
}) {
  const isMutual = stockType === 'mutual';
  const addPeriod    = () => setMutualPeriods([...mutualPeriods, { id: Date.now().toString(), dateFrom: '', dateTo: '' }]);
  const removePeriod = (id: string) => setMutualPeriods(mutualPeriods.filter(p => p.id !== id));
  const updatePeriod = (id: string, field: 'dateFrom' | 'dateTo', val: string) =>
    setMutualPeriods(mutualPeriods.map(p => p.id === id ? { ...p, [field]: val } : p));

  return (
    <div>
      <p className="text-[13px] text-gray-500 mb-5">
        {isMutual ? 'Add one or more valuation periods.' : 'Define the date window for your balance sheet calculations.'}
      </p>
      {!isMutual ? (
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Date from</label>
              <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Date to</label>
              <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest calculation up to</label>
              <input type="date" value={interestDateTo} onChange={e => setInterestDateTo(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest rate (% p.a.)</label>
              <input type="number" value={interestRate} min={0} step={0.1} onChange={e => setInterestRate(parseFloat(e.target.value) || 0)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
          </div>
        </div>
      ) : (
        <div className="space-y-3">
          {mutualPeriods.map((period, idx) => (
            <div key={period.id} className="border border-gray-200 rounded-xl p-4 relative bg-white">
              <div className="text-[12px] font-semibold text-gray-500 mb-3">Period {idx + 1}</div>
              {mutualPeriods.length > 1 && (
                <button onClick={() => removePeriod(period.id)} className="absolute top-3 right-3 text-gray-300 hover:text-red-400 transition text-lg">×</button>
              )}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-[11px] font-semibold text-gray-500 uppercase mb-1">Date from</label>
                  <input type="date" value={period.dateFrom} onChange={e => updatePeriod(period.id, 'dateFrom', e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
                </div>
                <div>
                  <label className="block text-[11px] font-semibold text-gray-500 uppercase mb-1">NAV date (to)</label>
                  <input type="date" value={period.dateTo} onChange={e => updatePeriod(period.id, 'dateTo', e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
                </div>
              </div>
            </div>
          ))}
          <button onClick={addPeriod} className="w-full py-2.5 border-2 border-dashed border-gray-200 rounded-xl text-[13px] text-gray-500 hover:border-[#534AB7] hover:text-[#534AB7] hover:bg-[#EEEDFE]/30 transition flex items-center justify-center gap-2">
            <FaPlus className="text-[11px]" /> Add another period
          </button>
          <div className="grid grid-cols-2 gap-4 pt-2">
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest calculation up to</label>
              <input type="date" value={interestDateTo} onChange={e => setInterestDateTo(e.target.value)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
            <div>
              <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Interest rate (% p.a.)</label>
              <input type="number" value={interestRate} min={0} step={0.1} onChange={e => setInterestRate(parseFloat(e.target.value) || 0)} className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
            </div>
          </div>
        </div>
      )}
      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition"><FaChevronLeft className="text-[11px]" /> Back</button>
        <button onClick={onNext} className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">Continue <FaChevronRight className="text-[11px]" /></button>
      </div>
    </div>
  );
}

// ─── Step 3: Financial Entries ────────────────────────────────────────────────

function Step3FinancialEntries({ parties, financialRecords, onSaved, onBack, onNext }: {
  parties: Party[]; financialRecords: FinancialEntry[];
  onSaved: () => void; onBack: () => void; onNext: () => void;
}) {
  const [selectedPartyId, setSelectedPartyId] = useState('');
  const [activeTab, setActiveTab] = useState<EntryType>('Closing');
  const [localRows, setLocalRows] = useState<FinancialEntry[]>([]);
  const [saving,    setSaving]    = useState(false);
  const [savedTabs, setSavedTabs] = useState<Record<string, Set<EntryType>>>({});

  useEffect(() => {
    if (!selectedPartyId) { setLocalRows([]); return; }
    const existing = financialRecords.filter(r => String(r.party_id) === selectedPartyId && r.record_type === activeTab);
    setLocalRows(existing.length > 0 ? existing : [makeBlankRow(selectedPartyId, activeTab)]);
  }, [selectedPartyId, activeTab, financialRecords]);

  function makeBlankRow(pid: string, type: EntryType): FinancialEntry {
    return { party_id: pid, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '', units: '', stock_name: '' };
  }

  const addRow    = () => setLocalRows(prev => [...prev, makeBlankRow(selectedPartyId, activeTab)]);
  const updateRow = (idx: number, field: keyof FinancialEntry, val: string) => {
    setLocalRows(prev => { const c = [...prev]; c[idx] = { ...c[idx], [field]: val }; return c; });
  };
  const removeRow = async (idx: number) => {
    const row = localRows[idx];
    if (row.id) { setSaving(true); await apiDeleteFinancialRecord(row.id); setSaving(false); onSaved(); }
    setLocalRows(prev => prev.filter((_, i) => i !== idx));
  };
  const saveCurrentTab = async () => {
    setSaving(true);
    for (const row of localRows.filter(r => r.amount && r.date)) {
      await apiSaveFinancialRecord({ ...row, party_id: selectedPartyId, record_type: activeTab });
    }
    setSaving(false); onSaved();
    setSavedTabs(prev => { const n = { ...prev }; if (!n[selectedPartyId]) n[selectedPartyId] = new Set(); n[selectedPartyId].add(activeTab); return n; });
  };
  const tabHasData = (type: EntryType) => !selectedPartyId ? false :
    savedTabs[selectedPartyId]?.has(type) ||
    financialRecords.some(r => String(r.party_id) === selectedPartyId && r.record_type === type && r.amount);

  const entryConfig = ENTRY_TYPES.find(e => e.type === activeTab)!;

  return (
    <div>
      <p className="text-[13px] text-gray-500 mb-5">Add manual financial entries per party. Optional — skip if not needed.</p>
      <div className="mb-5">
        <label className="block text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-1">Select party</label>
        <select value={selectedPartyId} onChange={e => setSelectedPartyId(e.target.value)}
          className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30 bg-white">
          <option value="">— choose a party to add entries —</option>
          {parties.map(p => <option key={p.id} value={String(p.id)}>{p.name}</option>)}
        </select>
      </div>
      {selectedPartyId && (
        <div>
          <div className="flex flex-wrap gap-2 mb-4">
            {ENTRY_TYPES.map(({ type, label }) => {
              const hasData = tabHasData(type); const isActive = activeTab === type;
              const cfg = ENTRY_TYPES.find(e => e.type === type)!;
              return (
                <button key={type} onClick={() => setActiveTab(type)}
                  style={isActive ? { background: cfg.color, borderColor: cfg.color, color: '#fff' }
                    : hasData ? { background: cfg.bg, borderColor: cfg.border, color: cfg.color }
                    : { background: '#fff', borderColor: '#D0D5DD', color: '#667085' }}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold border transition">
                  {hasData && !isActive && <FaCheck className="text-[10px]" />}
                  {label}
                </button>
              );
            })}
          </div>
          <div className="space-y-2 mb-3">
            {localRows.map((row, idx) => (
              <div key={idx} className="border border-gray-200 rounded-xl p-3" style={{ borderLeftColor: entryConfig.border, borderLeftWidth: 3 }}>
                {entryConfig.hasLabel && (
                  <div className="mb-3">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Label / description</label>
                    <input type="text" value={row.label || ''}
                      placeholder={activeTab === 'Expenses' ? 'e.g. DP charges, STT, custody fee…' : 'e.g. advisor fee Q3, PMS fee…'}
                      onChange={e => updateRow(idx, 'label', e.target.value)}
                      className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
                  </div>
                )}
                {activeTab === 'Sale' && (
                  <div className="grid grid-cols-2 gap-3 mb-3">
                    <div>
                      <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Stock name</label>
                      <input type="text" value={row.stock_name || ''} placeholder="Stock name" onChange={e => updateRow(idx, 'stock_name', e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none" />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Units</label>
                      <input type="number" value={row.units || ''} placeholder="Qty" onChange={e => updateRow(idx, 'units', e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none" />
                    </div>
                  </div>
                )}
                <div className="flex gap-3 items-end">
                  <div className="flex-1">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Date</label>
                    <input type="date" value={row.date ? row.date.slice(0, 10) : ''} onChange={e => updateRow(idx, 'date', e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
                  </div>
                  <div className="flex-1">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Amount (₹)</label>
                    <input type="number" value={row.amount} placeholder="0.00" onChange={e => updateRow(idx, 'amount', e.target.value)} className="w-full border rounded-lg px-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/20" />
                  </div>
                  <button onClick={() => removeRow(idx)} className="self-end p-2 rounded-lg border border-gray-200 text-gray-400 hover:bg-red-50 hover:border-red-200 hover:text-red-500 transition">
                    <FaTrash className="text-[12px]" />
                  </button>
                </div>
              </div>
            ))}
          </div>
          <div className="flex items-center gap-3">
            <button onClick={addRow} className="flex-1 py-2 border-2 border-dashed border-gray-200 rounded-xl text-[13px] text-gray-400 hover:border-[#534AB7] hover:text-[#534AB7] hover:bg-[#EEEDFE]/30 transition flex items-center justify-center gap-2">
              <FaPlus className="text-[11px]" /> Add entry
            </button>
            <button onClick={saveCurrentTab} disabled={saving} style={{ background: entryConfig.color }} className="px-5 py-2 text-white rounded-xl text-[13px] font-semibold disabled:opacity-50 transition flex items-center gap-2">
              {saving ? 'Saving…' : <><FaCheck className="text-[11px]" /> Save tab</>}
            </button>
          </div>
        </div>
      )}
      {!selectedPartyId && (
        <div className="flex flex-col items-center justify-center py-10 text-center text-gray-400">
          <span className="text-4xl mb-3">📋</span>
          <p className="text-[13px]">Select a party above to add financial entries,<br />or skip this step if not needed.</p>
        </div>
      )}
      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition"><FaChevronLeft className="text-[11px]" /> Back</button>
        <button onClick={onNext} className="flex items-center gap-2 px-6 py-2.5 bg-[#534AB7] text-white rounded-lg font-semibold text-[13px] hover:bg-[#3C3489] transition">Review <FaChevronRight className="text-[11px]" /></button>
      </div>
    </div>
  );
}

// ─── Step 4 ───────────────────────────────────────────────────────────────────

function Step4Review({ stockType, dateFrom, dateTo, interestRate, interestDateTo, mutualPeriods, financialRecords, parties, onBack, onGenerate }: {
  stockType: StockType; dateFrom: string; dateTo: string; interestRate: number; interestDateTo: string;
  mutualPeriods: MutualPeriod[]; financialRecords: FinancialEntry[]; parties: Party[];
  onBack: () => void; onGenerate: () => void;
}) {
  const typeLabel    = STOCK_TYPES.find(t => t.key === stockType)?.label || '';
  const totalEntries = financialRecords.filter(r => r.amount).length;
  const summaryItems = [
    { label: 'Investment type',  value: typeLabel },
    { label: 'Date from', value: dateFrom ? new Date(dateFrom).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : 'All' },
    { label: 'Date to',   value: dateTo   ? new Date(dateTo).toLocaleDateString('en-IN',   { day: '2-digit', month: 'short', year: 'numeric' }) : 'Latest' },
    { label: 'Interest rate', value: `${interestRate}% p.a.` },
    ...(stockType === 'mutual' ? [{ label: 'NAV periods', value: String(mutualPeriods.length) }] : []),
    { label: 'Financial entries', value: `${totalEntries} entr${totalEntries === 1 ? 'y' : 'ies'}` },
  ];
  const partyEntryMap: Record<string, number> = {};
  financialRecords.forEach(r => { if (!partyEntryMap[r.party_id]) partyEntryMap[r.party_id] = 0; if (r.amount) partyEntryMap[r.party_id]++; });
  const partiesWithEntries = Object.keys(partyEntryMap).filter(pid => partyEntryMap[pid] > 0);

  return (
    <div>
      <p className="text-[13px] text-gray-500 mb-5">Review your configuration before generating the balance sheet.</p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-5">
        {summaryItems.map(({ label, value }) => (
          <div key={label} className="bg-gray-50 rounded-xl p-3 border border-gray-100">
            <div className="text-[11px] text-gray-400 mb-1">{label}</div>
            <div className="text-[14px] font-semibold text-gray-800">{value}</div>
          </div>
        ))}
      </div>
      {partiesWithEntries.length > 0 && (
        <div className="mb-5">
          <div className="text-[11px] font-semibold text-gray-500 uppercase tracking-wide mb-2">Parties with manual entries</div>
          <div className="flex flex-wrap gap-2">
            {partiesWithEntries.map(pid => {
              const party = parties.find(p => String(p.id) === pid);
              return (
                <span key={pid} className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-[12px] font-semibold bg-[#E1F5EE] border border-[#5DCAA5] text-[#085041]">
                  <FaCheck className="text-[10px]" /> {party?.name || pid} ({partyEntryMap[pid]})
                </span>
              );
            })}
          </div>
        </div>
      )}
      <div className="bg-[#EEEDFE] border border-[#AFA9EC] rounded-xl p-4 text-[13px] text-[#3C3489] mb-2">
        <strong>Ready to generate.</strong> Click below to compute the full party balance sheet.
      </div>
      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-[13px] text-gray-500 hover:bg-gray-50 transition"><FaChevronLeft className="text-[11px]" /> Back</button>
        <button onClick={onGenerate} className="flex items-center gap-2 px-8 py-2.5 bg-[#1D9E75] text-white rounded-lg font-semibold text-[14px] hover:bg-[#0F6E56] transition shadow-lg shadow-green-200">
          <FaDatabase className="text-[12px]" /> Generate balance sheet
        </button>
      </div>
    </div>
  );
}

// ─── Inline Entry Modal ───────────────────────────────────────────────────────

function MultiEntryForm({ type, partyId, partyName, existingRecords, onClose, onSaved }: {
  type: EntryType; partyId: string; partyName: string;
  existingRecords: FinancialEntry[]; onClose: () => void; onSaved: () => void;
}) {
  const cfg = ENTRY_TYPES.find(e => e.type === type)!;
  const [rows,   setRows]   = useState<FinancialEntry[]>(
    existingRecords.length > 0 ? existingRecords
      : [{ party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '' }]
  );
  const [saving, setSaving] = useState(false);

  const addRow    = () => setRows(prev => [...prev, { party_id: partyId, record_type: type, amount: '', date: new Date().toISOString().split('T')[0], label: '' }]);
  const updateRow = (idx: number, field: keyof FinancialEntry, value: string) => {
    setRows(prev => { const c = [...prev]; c[idx] = { ...c[idx], [field]: value }; return c; });
  };
  const removeRow = async (idx: number) => {
    const row = rows[idx];
    if (row.id) { setSaving(true); await apiDeleteFinancialRecord(row.id); setSaving(false); onSaved(); }
    setRows(prev => prev.filter((_, i) => i !== idx));
  };
  const handleSave = async () => {
    setSaving(true);
    for (const row of rows) {
      if (!row.amount || !row.date) continue;
      await apiSaveFinancialRecord({ ...row, party_id: partyId, record_type: type });
    }
    setSaving(false); onSaved(); onClose();
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden border border-gray-200">
        <div className="p-4 text-white flex justify-between items-center" style={{ background: cfg.color }}>
          <div>
            <h3 className="font-bold text-lg">{cfg.label}</h3>
            <p className="text-[12px] opacity-80">{partyName}</p>
          </div>
          <button onClick={onClose} className="text-2xl leading-none hover:opacity-70">&times;</button>
        </div>
        <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4">
          {rows.map((entry, idx) => (
            <div key={idx} className="border-b pb-4 last:border-0 last:pb-0">
              {cfg.hasLabel && (
                <div className="mb-3">
                  <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Label / description</label>
                  <input type="text" value={entry.label || ''}
                    placeholder={type === 'Expenses' ? 'e.g. DP charges, STT, custody fee…' : 'e.g. advisor fee Q3, PMS fee…'}
                    onChange={e => updateRow(idx, 'label', e.target.value)}
                    className="w-full border rounded-lg p-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#534AB7]/30" />
                </div>
              )}
              <div className="flex gap-3 items-end">
                <div className="flex-1">
                  <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Date</label>
                  <input type="date" value={entry.date ? entry.date.slice(0,10) : ''} onChange={e => updateRow(idx, 'date', e.target.value)} className="w-full border rounded-lg p-2 text-sm" />
                </div>
                <div className="flex-1">
                  <label className="text-[10px] font-bold text-gray-500 uppercase block mb-1">Amount (₹)</label>
                  <input type="number" value={entry.amount} placeholder="0.00" onChange={e => updateRow(idx, 'amount', e.target.value)} className="w-full border rounded-lg p-2 text-sm" />
                </div>
                <button onClick={() => removeRow(idx)} className="text-red-400 p-2 pb-3 hover:text-red-600 transition">🗑️</button>
              </div>
            </div>
          ))}
          <button onClick={addRow} className="w-full py-2 border-2 border-dashed rounded-lg font-bold hover:opacity-80 transition text-sm" style={{ borderColor: cfg.border, color: cfg.color }}>
            + Add another entry
          </button>
        </div>
        <div className="p-4 bg-gray-50 flex gap-3 justify-end border-t">
          <button onClick={onClose} className="px-4 py-2 text-gray-600 font-semibold hover:text-gray-800">Cancel</button>
          <button onClick={handleSave} disabled={saving} className="px-6 py-2 text-white rounded-lg font-bold shadow-lg disabled:opacity-60" style={{ background: cfg.color }}>
            {saving ? 'Saving…' : 'Save all'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Main Component ───────────────────────────────────────────────────────────

function UnifiedBalanceSheet() {
  const _savedConfig = loadWizardConfig();

  const [wizardStep,        setWizardStep]        = useState<WizardStep>(1);
  const [wizardDone,        setWizardDone]        = useState<boolean>(!!_savedConfig);
  const [selectedStockType, setSelectedStockType] = useState<StockType>(_savedConfig?.selectedStockType ?? 'all');
  const [wizardDateFrom,    setWizardDateFrom]    = useState(_savedConfig?.dateFrom ?? '');
  const [wizardDateTo,      setWizardDateTo]      = useState(_savedConfig?.dateTo ?? '');
  const [dateFrom,          setDateFrom]          = useState(_savedConfig?.dateFrom ?? '');
  const [dateTo,            setDateTo]            = useState(_savedConfig?.dateTo ?? '');
  const [interestDateTo,    setInterestDateTo]    = useState(_savedConfig?.interestDateTo ?? '');
  const [interestPercentage,setInterestPercentage]= useState<number>(_savedConfig?.interestPercentage ?? 3);
  const [mutualPeriods,     setMutualPeriods]     = useState<MutualPeriod[]>(_savedConfig?.mutualPeriods ?? [{ id: '1', dateFrom: '', dateTo: '' }]);

  const [parties,           setParties]           = useState<Party[]>([]);
  const [stocks,            setStocks]            = useState<PartyStockDBType[]>([]);
  const [updates,           setUpdates]           = useState<StockCurrentAmountRecord[]>([]);
  const [sellStocks,        setSellStocks]        = useState<SellStockRecord[]>([]);
  const [withdrawals,       setWithdrawals]       = useState<WithdrawalRecord[]>([]);
  const [financialRecords,  setFinancialRecords]  = useState<FinancialEntry[]>([]);
  const [indexPriceHistory, setIndexPriceHistory] = useState<IndexPriceRecord[]>([]);
  const [farmForm,          setFarmForm]          = useState({ name: '', email: '', phone: '', address: '' });
  const [calculationFormulasConfig, setCalculationFormulasConfig] = useState<CalculationFormulaConfig | null>(null);

  const [search,           setSearch]           = useState('');
  const [page,             setPage]             = useState(1);
  const perPage = 10;
  const [filters,          setFilters]          = useState<Record<string, string | null>>({});
  const [uniqueColumnValues,setUniqueColumnValues]=useState<Record<string,string[]>>({});
  const [selectedParty,    setSelectedParty]    = useState<Party | null>(null);
  const [showPartyModal,   setShowPartyModal]   = useState(false);
  const [partyModalSheet,  setPartyModalSheet]  = useState<ModalSheetView>('overall');
  const [globalQTLY,       setGlobalQtly]       = useState(false);
  const [entryModal, setEntryModal] = useState<{ isOpen: boolean; type: EntryType; partyId: string }>
    ({ isOpen: false, type: 'Closing', partyId: '' });

  const fileInputRef   = useRef<HTMLInputElement>(null);
  const location       = useLocation();
  const [partyIdFromUrl, setPartyIdFromUrl] = useState<string | null>(null);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    let pid  = sp.get('party');
    if (!pid) { const m = location.pathname.match(/\/(\d+)$/); if (m) pid = m[1]; }
    setPartyIdFromUrl(pid);
  }, [location]);

  useEffect(() => {
    try { const r = localStorage.getItem('calculationsFormulasConfigV1'); if (r) setCalculationFormulasConfig(JSON.parse(r)); } catch {}
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/auth/setting`);
        const arr = Array.isArray(res.data) ? res.data : [];
        const farm = arr.find((i: any) => i.meta_key === 'farm');
        if (farm) { const v = typeof farm.meta_value === 'string' ? JSON.parse(farm.meta_value || '{}') : farm.meta_value || {}; setFarmForm({ name: v.name || '', email: v.email || '', phone: v.phone || '', address: v.address || '' }); }
        const hist = arr.find((i: any) => i.meta_key === 'index_prices_history');
        if (hist) { const h = typeof hist.meta_value === 'string' ? JSON.parse(hist.meta_value || '[]') : hist.meta_value || []; if (Array.isArray(h)) setIndexPriceHistory(h.sort((a: any, b: any) => (b.date > a.date ? 1 : -1))); }
      } catch {}
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await settingapi();
        if (Array.isArray(res)) { const p = res.find((i: any) => i.meta_key === 'percentage'); if (p && !isNaN(parseFloat(p.meta_value))) setInterestPercentage(parseFloat(p.meta_value)); }
      } catch {}
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/addparty`);
        if (!res.ok) return;
        const data = await res.json();
        if (Array.isArray(data)) setParties(data.map((item: any) => ({ ...item, categories: Array.isArray(item.categories) ? item.categories : typeof item.categories === 'string' ? (item.categories.trim().startsWith('[') ? JSON.parse(item.categories) : item.categories.split(',').map((c: string) => c.trim())) : [] })));
      } catch {}
    })();
  }, []);

  const fetchStocksData  = useCallback(async () => { try { const r = await stocksData(); setStocks(Array.isArray(r) ? r : []); } catch { setStocks([]); } }, []);
  const fetchUpdatesData = useCallback(async () => { try { const d = await updatestocksApi(); setUpdates(Array.isArray(d) ? d : []); } catch { setUpdates([]); } }, []);
  useEffect(() => { fetchStocksData(); fetchUpdatesData(); }, [fetchStocksData, fetchUpdatesData]);
  useEffect(() => { (async () => setSellStocks(await fetchSellStocks()))(); }, []);
  useEffect(() => {
    (async () => {
      const arr = await fetchWithdrawals();
      setWithdrawals((arr || []).map(wd => {
        let categories: any[] = [];
        if (wd.catrgories) { try { const a = JSON.parse(wd.catrgories); if (Array.isArray(a) && a.length > 0 && typeof a[0] === 'string') { categories = JSON.parse(a[0]); if (!Array.isArray(categories)) categories = [categories]; } } catch {} }
        return { ...wd, categories };
      }));
    })();
  }, []);

  const loadFinancialRecords = useCallback(async () => { setFinancialRecords(await apiFetchFinancialRecords()); }, []);
  useEffect(() => { loadFinancialRecords(); }, [loadFinancialRecords]);

  // const generateBalanceSheet = () => { setDateFrom(wizardDateFrom); setDateTo(wizardDateTo); setWizardDone(true); setPage(1); };
  const generateBalanceSheet = () => {
    setDateFrom(wizardDateFrom);
    setDateTo(wizardDateTo);
    setWizardDone(true);
    setPage(1);
    saveWizardConfig({
      selectedStockType,
      dateFrom: wizardDateFrom,
      dateTo: wizardDateTo,
      interestDateTo,
      interestPercentage,
      mutualPeriods,
    });
  };
  // const resetWizard          = () => { setWizardDone(false); setWizardStep(1); };
  const resetWizard = () => {
    localStorage.removeItem(WIZARD_STORAGE_KEY);
    setWizardDone(false);
    setWizardStep(1);
  };

  const isInDateRange = (dateStr: string) => {
    if (!dateStr) return true;
    const date = new Date(dateStr);
    if (dateFrom && date < new Date(dateFrom)) return false;
    if (dateTo   && date > new Date(dateTo))   return false;
    return true;
  };

  const getFilteredRecords = useCallback(
    (partyId: string, type: FinancialEntry['record_type'], from?: string, to?: string): FinancialEntry[] =>
      financialRecords.filter(r => {
        if (String(r.party_id) !== String(partyId) || r.record_type !== type) return false;
        if (from && new Date(r.date) < new Date(from)) return false;
        if (to   && new Date(r.date) > new Date(to))   return false;
        return true;
      }),
    [financialRecords]
  );

  const sumRecords = (records: FinancialEntry[]) => records.reduce((s, r) => s + (parseFloat(r.amount) || 0), 0);

  // ── KEY FIX: partyClosingAmounts derived from DB financialRecords ──────────
  // Instead of local state, we compute closing amount per party from saved Closing records.
  // This means every Closing entry saved to DB is automatically reflected here.
  const partyClosingAmounts = React.useMemo((): Record<string, number> => {
    const map: Record<string, number> = {};

    // Group closing records by party, apply date filter, then pick the latest (by date & id as tie breaker)
    const closingMap: Record<
      string,
      { date: Date; amount: number; rawDate: string; recordId: any }
    > = {};

    financialRecords
      .filter(r => r.record_type === "Closing" && r.amount)
      .forEach((r) => {
        const pid = String(r.party_id);
        if (!r.date) return;

        const d = new Date(r.date);
        // If filtered, only consider records inside date range
        if (dateFrom && d < new Date(dateFrom)) return;
        if (dateTo && d > new Date(dateTo)) return;

        // Compare with existing for same party: take latest by date, if same date then by id
        if (
          !closingMap[pid] ||
          d > closingMap[pid].date ||
          (d.getTime() === closingMap[pid].date.getTime() &&
            (r.id || 0) > (closingMap[pid].recordId || 0))
        ) {
          closingMap[pid] = {
            date: d,
            rawDate: r.date,
            amount: parseFloat(r.amount) || 0,
            recordId: r.id || 0,
          };
        }
      });

    Object.entries(closingMap).forEach(([pid, entry]) => {
      map[pid] = entry.amount;
    });

    return map;
  }, [financialRecords, dateFrom, dateTo]);

  const partySundryCreditorsMap = React.useMemo(() => {
    if (!updates.length || !stocks.length) return {};
    const stockIdToParty = new Map<string, any>();
    for (const stk of stocks) stockIdToParty.set(String(stk.id), stk.party_id);
    const partyTotals: Record<string, number> = {};
    for (const update of updates) {
      const party_id = stockIdToParty.get(String(update.stock_id));
      if (!party_id) continue;
      const inDate = !update.current_price_date || ((!dateFrom || new Date(update.current_price_date) >= new Date(dateFrom)) && (!dateTo || new Date(update.current_price_date) <= new Date(dateTo)));
      if (!inDate) continue;
      if (typeof update.sundry_creditors !== 'undefined' && !isNaN(Number(update.sundry_creditors))) {
        if (!partyTotals[party_id]) partyTotals[party_id] = 0;
        partyTotals[party_id] += Number(update.sundry_creditors);
      }
    }
    return partyTotals;
  }, [updates, stocks, dateFrom, dateTo]);

  const partyAggregatedRows = React.useMemo(() => {
    if (!parties.length || !stocks.length) return [];
    const result: any[] = [];
    for (const party of parties) {
      const partyStocksArr = stocks.filter(stk => String(stk.party_id) === String(party.id));
      let total_purchased = 0, total_used = 0, total_earning = 0, total_indirect_charges = 0;
      const end = dateTo ? new Date(dateTo) : new Date();
      const total_interest = Number(party.total_amount || 0) * (interestPercentage / 100) * getMonthDiff2(party.date, end);

      const filteredSells = sellStocks.filter(s => String(s.party_id) === String(party.id) && (!dateFrom || new Date(s.date) >= new Date(dateFrom)) && (!dateTo || new Date(s.date) <= new Date(dateTo)));
      const total_sales_amount = filteredSells.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
      const total_sales_units  = filteredSells.reduce((sum, s) => sum + (parseFloat(s.sell_units)  || 0), 0);
      const filteredWD = withdrawals.filter(w => String(w.party_id) === String(party.id) && (!dateFrom || new Date(w.date) >= new Date(dateFrom)) && (!dateTo || new Date(w.date) <= new Date(dateTo)));
      const total_withdrawal_amount = filteredWD.reduce((sum, w) => sum + (parseFloat(String(w.amount)) || 0), 0);

      const stock_aggregate: any[] = [];
      for (const stk of partyStocksArr) {
        const allCats = parseCategoriesForDb(stk.categories);
        // const cats    = selectedStockType === 'all' ? allCats : allCats.filter(cat => STOCK_TYPES.find(t => t.key === selectedStockType)?.investmentTypes.includes(cat.investment_type));
        const cats = selectedStockType === 'all'
  ? allCats
  : allCats.filter(cat => {
      if (selectedStockType === 'equity') {
        return cat.category?.toLowerCase() === 'equity';
      }
      if (selectedStockType === 'mutual') {
        return ['mutul', 'mutul fund', 'mutul_fund'].includes(cat.category?.toLowerCase());
      }
      if (selectedStockType === 'fno') {
        return ['f&o', 'fno', 'futures', 'options'].includes(cat.category?.toLowerCase());
      }
      // direct, structure → keep original investment_type matching
      return STOCK_TYPES.find(t => t.key === selectedStockType)?.investmentTypes.includes(cat.investment_type);
    });
        for (const catObj of cats) {
          const indirectCharges = Number(catObj.indirect_charges || 0);
          const opening         = Number(catObj.total_amount || 0);
          const purchaseDate    = stk.date_of_purchase || stk.date || '';
          const inDate          = isInDateRange(purchaseDate);
          const chronHistory    = [...getAllCurrentAmountsFor(stk.id, catObj.id ?? '', updates, dateFrom, dateTo)].sort((a, b) => (a.current_price_date > b.current_price_date ? 1 : -1));
          const records: any[]  = [];
          if (inDate) records.push({ category: catObj.category, unit: catObj.unit, date_of_purchase: purchaseDate, opening_balance: opening, update_history: [], total_purchased: opening, total_used: 0, total_earning: 0, indirect_charges: indirectCharges, per_unit_charge: Number(catObj.perUnitCharge || 0), total_profit_and_loss: 0 });
          let totalStockUsed = 0, totalStockEarning = 0, total_profit_and_loss = 0;
          const update_history: any[] = [];
          let prevAmount = opening;
          for (const rec of chronHistory) {
            const thisAmount    = Number(rec.current_price || 0);
            const used          = thisAmount - prevAmount;
            const profitAndLoss = thisAmount - (prevAmount + indirectCharges);
            total_profit_and_loss += profitAndLoss;
            const entry: any = { date: rec.current_price_date, current_amount: thisAmount, used, earning: profitAndLoss, profitAndLoss };
            if (rec.sundry_creditors != null) { entry.dividend = Number(rec.sundry_creditors); entry.sundry_creditors = Number(rec.sundry_creditors); }
            update_history.push(entry);
            totalStockUsed += used; totalStockEarning += profitAndLoss;
          }
          if (inDate && records.length > 0) { records[0].update_history = update_history; records[0].total_used = totalStockUsed; records[0].total_earning = totalStockEarning; records[0].total_profit_and_loss = total_profit_and_loss; }
          if (inDate) { total_purchased += opening + indirectCharges; total_indirect_charges += indirectCharges; }
          total_used += totalStockUsed; total_earning += totalStockEarning;
          let se = stock_aggregate.find(s => s.stock_name === catObj.stock_name);
          if (!se) stock_aggregate.push({ stock_name: catObj.stock_name, records });
          else se.records.push(...records);
        }
      }
      if (stock_aggregate.length > 0) result.push({ party, stocks: stock_aggregate, total_purchased, total_used, total_earning, total_indirect_charges, total_interest, total_sales_amount, total_sales_units, total_withdrawal_amount, withdrawals_details: filteredWD });
    }
    return result;
  }, [parties, stocks, updates, dateFrom, dateTo, interestPercentage, sellStocks, withdrawals, selectedStockType]);

  useEffect(() => { if (partyAggregatedRows.length) setUniqueColumnValues({ party_name: partyAggregatedRows.map(r => r.party.name) }); }, [partyAggregatedRows]);

  const calculateReducingInterest = (party: Party, withdrawalsList: WithdrawalRecord[], interestRate: number, endDate: string) => {
    const start = new Date(party.date), end = new Date(endDate);
    let currentPrincipal = parseFloat(String(party.total_amount || 0));
    let totalInterest = 0, lastDate = new Date(start);
    const pw = withdrawalsList.filter(w => String(w.party_id) === String(party.id))
      .map(w => ({ date: new Date(w.date), amount: parseFloat(String(w.amount || 0)) }))
      .filter(w => w.date > start && w.date <= end)
      .sort((a, b) => a.date.getTime() - b.date.getTime());
    const totalWithdrawal = pw.reduce((sum, w) => sum + w.amount, 0);
    for (const wd of pw) {
      const days = Math.floor((wd.date.getTime() - lastDate.getTime()) / 86400000);
      if (days > 0) totalInterest += (currentPrincipal * interestRate / 36500) * days;
      currentPrincipal -= wd.amount; lastDate = new Date(wd.date);
    }
    const finalDays = Math.floor((end.getTime() - lastDate.getTime()) / 86400000);
    if (finalDays > 0) totalInterest += (currentPrincipal * interestRate / 36500) * finalDays;
    return { accumulatedInterest: totalInterest, remainingPrincipal: currentPrincipal, totalWithdrawal };
  };

  // ── Build P&L ──────────────────────────────────────────────────────────────
  function buildFinalSheetDataForParty(party: Party) {
    const fmt        = (n: number) => n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
    const partyIdStr = String(party.id);
    const partyStockRow = partyAggregatedRows.find(r => r.party.id === party.id);

    const lossRecs       = getFilteredRecords(partyIdStr, 'Loss',       dateFrom, dateTo);
    const profitRecs     = getFilteredRecords(partyIdStr, 'Profit',     dateFrom, dateTo);
    const commissionRecs = getFilteredRecords(partyIdStr, 'Commission', dateFrom, dateTo);
    const expensesRecs   = getFilteredRecords(partyIdStr, 'Expenses',   dateFrom, dateTo);

    const lossAmt       = sumRecords(lossRecs);
    const profitAmt     = sumRecords(profitRecs);
    const commissionAmt = sumRecords(commissionRecs);
    const expensesAmt   = sumRecords(expensesRecs);
    // closing amount comes from partyClosingAmounts (derived from DB)
    const closingOverride = partyClosingAmounts[partyIdStr] || 0;

    const openingStock = parties.filter(p => p.id === party.id).reduce((s, p) => s + (Number(p.total_amount) || 0), 0);
    const end          = dateTo ? new Date(dateTo) : new Date();
    const months       = getMonthDiff(party.date, end, stocks, party.id);
    const interestExpenses = (Number(party.total_amount || 0)) / 2 * (interestPercentage / 100) * months;

    let sharesPurchased = 0, directExpenses = 0, purchases = 0;
    for (const stk of partyStocksRaw) {
      const pd = stk.date_of_purchase || stk.date || '';
      if (!isInDateRange(pd)) continue;
      parseCategoriesForDb(stk.categories).forEach(c => {
        purchases += Number(c.total_amount || 0);
        if (c.investment_type === 'structure') sharesPurchased += Number(c.total_amount || 0) + Number(c.indirect_charges || 0);
        if (c.investment_type === 'direct')    directExpenses  += Number(c.total_amount || 0);
      });
    }
    if (!calculationFormulasConfig?.purchaseShare && calculationFormulasConfig?.purchaseShare != undefined) sharesPurchased = 0;

    let totalSales = 0, soldStockCost = 0, soldStockIndirect = 0, soldIndirectCharges = 0, totalHoldingCost = 0;
    for (const stk of partyStocksRaw) {
      if (!isInDateRange(stk.date_of_purchase || stk.date || '')) continue;
      parseCategoriesForDb(stk.categories).forEach(c => {
        const pUnits = parseFloat(c.unit) || 0, origAmt = Number(c.total_amount || 0), origInd = Number(c.indirect_charges || 0);
        const origPPU = pUnits > 0 ? origAmt / pUnits : 0;
        let currentPAmt = origAmt;
        const lu = getLatestCurrentAmountFor(stk.id, c.id, updates, dateFrom, dateTo);
        if (lu) currentPAmt = Number(lu.current_price);
        const currentPPU = pUnits > 0 ? (currentPAmt + origInd) / pUnits : 0;
        const ss = sellStocks.filter(s => String(s.party_id) === String(party.id) && s.stock_name === c.stock_name);
        const soldUnits = ss.reduce((sum, s) => sum + (parseFloat(s.sell_units) || 0), 0);
        totalSales        += ss.reduce((sum, s) => sum + (parseFloat(s.sell_amount) || 0), 0);
        soldIndirectCharges += ss.reduce((sum, s) => sum + (parseFloat(s.indirect_charges) || 0), 0);
        if (soldUnits > 0) { soldStockCost += soldUnits * origPPU; soldStockIndirect += origInd; }
        const remUnits = pUnits - soldUnits;
        if (remUnits > 0) totalHoldingCost += remUnits * currentPPU;
      });
    }

    let dSales = totalSales, dSoldCost = soldStockCost;
    if (calculationFormulasConfig?.grossSaleCharges) { dSales -= soldIndirectCharges; dSoldCost += soldStockIndirect; }
    let grossProfit = dSales - dSoldCost;
    if (calculationFormulasConfig?.grossInterestCharges) grossProfit -= interestExpenses;

    const indirectIncome = partySundryCreditorsMap[partyIdStr] || 0;
    // profitcs uses closing from DB (closingOverride)
    const profitcs = Number(closingOverride) > 0
      ? (Number(closingOverride) - Number(totalHoldingCost))
      : (0 - Number(totalHoldingCost));
    let netLoss = grossProfit + profitcs;

    let netLossOverrideVal: number;
    if      (lossAmt > 0 && !profitAmt)    netLossOverrideVal = -lossAmt;
    else if (profitAmt > 0 && !lossAmt)    netLossOverrideVal =  profitAmt;
    else if (profitAmt > 0 && lossAmt > 0) netLossOverrideVal =  profitAmt - lossAmt;
    else                                   netLossOverrideVal =  netLoss;

    let netGrossFitOverrideVal = netLossOverrideVal;
    if (netLoss > 0) netLoss -= commissionAmt;

    const reducingBalanceData = calculateReducingInterest(party, withdrawals, interestPercentage * 12, interestDateTo || new Date().toISOString());
    purchases += totalSales;
    const withdrawalAmt   = partyStockRow?.total_withdrawal_amount || 0;
    const remainingAmount = (Number(party.total_amount) - sharesPurchased - interestExpenses) + indirectIncome + (totalSales - soldIndirectCharges) - withdrawalAmt;

    let dynIndirectExp = 0;
    if (calculationFormulasConfig?.indInterestCharges)    dynIndirectExp += interestExpenses;
    if (calculationFormulasConfig?.indPurchaseIndirect)   dynIndirectExp += soldStockIndirect;
    if (calculationFormulasConfig?.indPurchasedStockSale) dynIndirectExp += soldIndirectCharges;

    return {
      openingStock:   fmt(openingStock),
      CapitalAccount: fmt((openingStock - reducingBalanceData.totalWithdrawal) + reducingBalanceData.accumulatedInterest),
      remainingAmount: fmt(remainingAmount < 0 ? 0 : remainingAmount),
 
      holdingamt:     fmt(totalHoldingCost),
      totalWithdrawalAmount: fmt(withdrawalAmt),
      purchases:      fmt(purchases),
      sales:          fmt(totalSales),
      closingStock:   fmt(totalSales + netGrossFitOverrideVal),
      grossProfit:    fmt(netGrossFitOverrideVal),
      indirectExpenses: fmt(dynIndirectExp),
      interestExpenses: fmt(reducingBalanceData.accumulatedInterest+expensesAmt+commissionAmt),
      onlyinterestExpenses: fmt(reducingBalanceData.accumulatedInterest),
      commissionAmt:fmt(commissionAmt),
      expensesAmt:fmt(expensesAmt),
      indirectIncome:   fmt(indirectIncome),
      netLoss:        fmt(netLossOverrideVal),
      salesindirectcharges:          fmt(soldIndirectCharges),
      purchasetosellindirectcharges: fmt(soldStockIndirect),
      leftTotalTrading:  fmt(purchases + Math.max(grossProfit, 0)),
      rightTotalTrading: fmt(totalSales + (closingOverride || totalHoldingCost)),
      leftTotalPL:  fmt(openingStock + netLossOverrideVal),
      rightTotalPL: fmt(openingStock + netLossOverrideVal),
      directExpenses:  fmt(directExpenses),
      sharesPurchased: fmt(sharesPurchased),
      pnltotalcharges: fmt(dynIndirectExp),
      purchaseAccount: fmt(sharesPurchased + directExpenses),
      expenseEntries:    expensesRecs,
      commissionEntries: commissionRecs,
      raw: { openingStock, purchases, sales: totalSales, closingStock: totalSales + netGrossFitOverrideVal, grossProfit: netGrossFitOverrideVal, indirectExpenses: dynIndirectExp, indirectIncome, netLoss: netLossOverrideVal },
    };
  }

  // ── Balance sheet ──────────────────────────────────────────────────────────
  function buildBalanceSheetDetailsForParty(party: Party) {
    const parseN = (v: any) => typeof v === 'string' ? Number(v.replace(/,/g, '').replace(/[^0-9.-]+/g, '')) || 0 : Number(v) || 0;
    const pnl    = buildFinalSheetDataForParty(party);
    const partyStocksRaw = stocks.filter(stk => String(stk.party_id) === String(party.id));
    let indirectcharges = 0;
    for (const stk of partyStocksRaw) {
      if (!isInDateRange(stk.date_of_purchase || stk.date || '')) continue;
      parseCategoriesForDb(stk.categories).forEach(c => { indirectcharges += Number(c.indirect_charges || 0); });
    }
    const interestOnCap  = pnl.onlyinterestExpenses;
    const nestLossN      = parseN(pnl.netLoss);
    const interestExpN   = parseN(pnl.interestExpenses);
    const profitAndLoss  = nestLossN - interestExpN;
    const numericCA      = parseN(pnl.CapitalAccount);
    const beforeInt      = numericCA - interestExpN;
    // closingStockAmt comes from DB-derived partyClosingAmounts
    const closingStockAmt = partyClosingAmounts[String(party.id)];

    return {
      liabilities: [
        { label: <b>Capital Account</b>, amount: parseN(interestOnCap) + parseN(String(beforeInt)) },
        { label: <span style={{ paddingLeft: 12, display: 'inline-block', minWidth: 160 }}>Interest on capital<br />{party.display_name}</span>, amount: interestOnCap },
        { label: <span style={{ paddingLeft: 8, display: 'inline-block', minWidth: 160 }}></span>, amount: beforeInt },
        null,
        { label: <b>Current Liabilities</b>, amount: '' },
        { label: <span style={{ fontSize: '12px' }}>Indirect charges</span>, amount: indirectcharges },
        null,
        { label: <b>TOTAL</b>, amount: pnl.CapitalAccount },
      ],
      assets: [
        { label: <b>Current Assets</b>, amount: '' },
        // Closing Stocks: from DB closing records (partyClosingAmounts)
        { label: 'Closing Stocks', amount: closingStockAmt !== undefined ? closingStockAmt : '' },
        { label: 'Sundry Debtors', amount: String(pnl.remainingAmount || 0) },
        null,
        { label: <b>Profit &amp; Loss A/c</b>, amount: '' },
        { label: '', amount: profitAndLoss },
        null,
        { label: <b>TOTAL</b>, amount: pnl.CapitalAccount },
      ],
    };
  }

  // ── P&L render ─────────────────────────────────────────────────────────────
  function renderPnLModalContent(party: Party) {
    const data = buildFinalSheetDataForParty(party);
    const periodLabel = (dateFrom || dateTo)
      ? `${dateFrom ? new Date(dateFrom).toLocaleDateString('en-GB') : ''}${dateFrom && dateTo ? ' to ' : dateTo ? 'to ' : ''}${dateTo ? new Date(dateTo).toLocaleDateString('en-GB') : ''}`
      : 'Select date range';
    const fmt = (n: any) => typeof n === 'number' ? `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : n || '';
    const renderCell = (children: React.ReactNode, { bold, align = 'left', style = {}, colSpan }: any = {}) => (
      <td style={{ border: '0px solid #333', padding: '7px 8px', fontWeight: bold ? 700 : undefined, textAlign: align, fontSize: 15, ...style }} colSpan={colSpan}>{children}</td>
    );
    function addvalue(a: string, b: string) {
      return Number(a?.toString().replace(/,/g, '') || '0') + Number(b?.toString().replace(/,/g, '') || '0');
    }
    const netLossVal     = parseFloat(String(data.netLoss).replace(/,/g, '')) || 0;
    const interestExpVal = parseFloat(String(data.interestExpenses).replace(/,/g, '')) || 0;
    const netResult      = netLossVal - interestExpVal;
    // closing amount from DB
    const closingAmtForParty = partyClosingAmounts[String(party.id)];
    const showDirectClosing  = closingAmtForParty !== undefined;
    const totalLeft  = showDirectClosing ? fmt(netLossVal - interestExpVal) : fmt(data.leftTotalPL);
    const totalRight = showDirectClosing ? fmt(netLossVal - interestExpVal) : fmt(data.rightTotalPL);
    const totalLabel = showDirectClosing ? 'Direct Closing Amount' : 'Total';

    const rows: any[] = [
      ['', '', 'Sales Accounts', fmt(data.sales)],
      // Closing stock cell uses DB-derived value
      ['Purchase Accounts', fmt(data.sharesPurchased), 'Closing Stock', closingAmtForParty !== undefined ? fmt(closingAmtForParty) : '—'],
      calculationFormulasConfig?.purchaseShare ? [<span style={{ marginLeft: 12 }}>Shares Purchased</span>, fmt(data.sharesPurchased), '', ''] : [],
      calculationFormulasConfig?.purchaseDirect ? [<span style={{ marginLeft: 12 }}>Direct Purchased</span>, fmt(data.directExpenses), '', ''] : [],
      [
        <span style={{ fontWeight: 600 }}>Gross Profit b/f<p className="text-[8px]">This include indirect expenses</p></span>,
        fmt(data.netLoss),
        <span style={{ fontWeight: 600 }}>Gross Profit c/o</span>,
        <span style={{ fontWeight: 600 }}>{fmt(data.netLoss)}<br />{fmt(addvalue(data.sharesPurchased, data.directExpenses))}</span>,
      ],
      [
        <span style={{ fontWeight: 600 }}>Indirect Expenses</span>,
        fmt(data.interestExpenses),
   
        <span style={{ fontWeight: 600 }}>Indirect Incomes</span>,
        fmt(data.indirectIncome),
      ],
      ...((data.expenseEntries || []).map((entry: FinancialEntry) => [
        <span style={{ paddingLeft: 22, fontSize: '12px', color: '#633806' }}>
          {entry.label || 'Expense'}
          <span style={{ marginLeft: 8, color: '#aaa', fontSize: '11px' }}>{entry.date ? new Date(entry.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : ''}</span>
        </span>,
        <span style={{ fontSize: '12px' }}>{fmt(Number(entry.amount) || 0)}</span>,
        <span />, <span />, { className: '' },
      ])),
      ...((data.commissionEntries || []).map((entry: FinancialEntry) => [
        <span style={{ paddingLeft: 22, fontSize: '12px', color: '#3C3489' }}>
          {entry.label || 'Commission'}
          <span style={{ marginLeft: 8, color: '#aaa', fontSize: '11px' }}>{entry.date ? new Date(entry.date).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : ''}</span>
        </span>,
        <span style={{ fontSize: '12px', color: '#3C3489' }}>{fmt(Number(entry.amount) || 0)}</span>,
        <span />, <span />, { className: '' },
      ])),
      calculationFormulasConfig?.indInterestCharges ? [
        <span style={{ paddingLeft: 22, fontSize: '12px' }}>Interest Expenses</span>,
        <span style={{ paddingLeft: 22, fontSize: '12px' }}>{fmt(data.onlyinterestExpenses)}</span>,
        <span style={{ fontWeight: 600 }}>{netResult < 0 ? 'Net Loss: ' : 'Net Profit: '}</span>,
        <span style={{ fontWeight: 600 }}>{fmt(netResult)}</span>,
        { className: '' },
      ] : [],
    ];

    return (
      <div style={{ background: '#fff', maxWidth: 900, margin: '0 auto', padding: 12 }} id="renderpnl">
        <h2 style={{ fontWeight: 700, color: '#000', textAlign: 'center', fontSize: 19, marginBottom: 0, letterSpacing: 1 }}>{farmForm.name}</h2>
        <div style={{ textAlign: 'center', fontSize: 15, marginBottom: 6 }}>{farmForm.address}</div>
        <div style={{ textAlign: 'center', fontWeight: 700, fontSize: 18, margin: '0 0 2px 0' }}>Profit &amp; Loss A/c</div>
        <div style={{ textAlign: 'center', fontSize: 13, marginBottom: 6 }}>{periodLabel}</div>
        <div style={{ overflowX: 'auto', marginTop: 11 }}>
          <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: 700 }}>
            <thead>
              <tr style={{ border: '1px solid #0000006e', borderLeft: 'none', borderRight: 'none' }}>
                {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#fff' } })}
                {renderCell(periodLabel,   { bold: true, align: 'center', style: { background: '#fff' } })}
                {renderCell('Particulars', { bold: true, align: 'center', style: { background: '#fff' } })}
                {renderCell(periodLabel,   { bold: true, align: 'center', style: { background: '#fff' } })}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => {
                if (!row || row.length === 0) return null;
                const trProps = row[4] && typeof row[4] === 'object' ? row[4] : {};
                const trClass = trProps.className || '';
                const isHidden = trClass === 'hidden';
                return (
                  <tr key={i} className={trClass}>
                    {renderCell(row[0])}
                    {renderCell(row[1], { align: isHidden ? undefined : 'right', style: { borderRight: '1px solid black' } })}
                    {renderCell(row[2])}
                    {renderCell(row[3], { align: isHidden ? undefined : 'right' })}
                  </tr>
                );
              })}
              <tr style={{ border: '1px solid #0000006e', borderLeft: 'none', borderRight: 'none' }}>
                {renderCell(<span style={{ fontWeight: 700 }}>{totalLabel}</span>, { align: 'center', style: { background: '#fff' } })}
                {renderCell(totalLeft, { bold: true, align: 'right', style: { background: '#fff', borderRight: '1px solid black' } })}
                {renderCell(<span style={{ fontWeight: 700 }}>{totalLabel}</span>, { align: 'center', style: { background: '#fff' } })}
                {renderCell(totalRight, { bold: true, align: 'right', style: { background: '#fff' } })}
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // ── Balance sheet render ───────────────────────────────────────────────────
  function renderBalanceSheetModalContent(party: Party) {
    const balance     = buildBalanceSheetDetailsForParty(party);
    const headerLabel = dateTo ? `(As at ${new Date(dateTo).toLocaleDateString()})` : 'select date range';
    return (
      <div style={{ background: '#fff' }} id="balancesheet">
        <h2 style={{ fontWeight: 700, color: '#6742c7', textAlign: 'center', fontSize: 22 }}>{farmForm.name}</h2>
        <div style={{ textAlign: 'center', marginBottom: 8 }}>{farmForm.address}</div>
        <h3 style={{ textAlign: 'center', fontWeight: 700, fontSize: 20, margin: '18px 0 0 0' }}>BALANCE SHEET</h3>
        <div style={{ textAlign: 'center', color: '#666', marginBottom: 6 }}>{headerLabel}</div>
        <div style={{ textAlign: 'center', color: '#6742c7', marginBottom: 5, fontWeight: 'bold' }}>Showing data for: {formatPeriod(dateFrom, dateTo)}</div>
        <div style={{ display: 'flex', gap: 20, justifyContent: 'center', alignItems: 'flex-start' }}>
          {([{ title: 'LIABILITIES', items: balance.liabilities }, { title: 'ASSETS', items: balance.assets }] as const).map(({ title, items }) => (
            <div key={title} style={{ flex: 1, minWidth: 320 }}>
              <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 9, color: '#6742c7' }}>{title}</div>
              <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: 14 }}>
                <thead><tr>
                  <th className="border-y border-[#d0d5dd]" style={{ background: '#fff' }}>Particulars</th>
                  <th className="border-y border-[#d0d5dd]" style={{ background: '#fff' }}>Amount (₹)</th>
                </tr></thead>
                <tbody>
                  {(items as any[]).map((item: any, idx: number) =>
                    item === null ? (
                      <tr key={idx}><td colSpan={2} style={{ border: 'none', height: '6px' }}></td></tr>
                    ) : (
                      <tr key={idx}>
                        <td style={{ padding: '5px 8px' }}>{item.label}</td>
                        <td style={{ textAlign: 'right', padding: '5px 8px', color: Number(item.amount) < 0 ? '#B91C1C' : undefined }}>
                          {item.amount !== '' && item.amount !== undefined
                            ? typeof item.amount === 'string' ? item.amount
                              : Number(item.amount).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : ''}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    );
  }

  // ── QTLY render ────────────────────────────────────────────────────────────
  function renderQTLYContent(partiesList: Party[]) {
    const periods = [...indexPriceHistory].sort((a, b) => (a.date > b.date ? 1 : -1)).map(record => {
      const d = new Date(record.date);
      return { label: `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getFullYear()).slice(-2)}`, key: record.date, sensex: record.sensexPrice || '---' };
    });
    const fmt2 = (n: any, isPercent = false) => n == null ? '0.00' : isPercent ? (typeof n === 'number' ? n.toFixed(2) : n) + '%' : typeof n === 'number' ? n.toLocaleString('en-IN', { minimumFractionDigits: 2 }) : n;
    return (
      <div style={{ background: '#fff', maxWidth: 1200, margin: '0 auto', padding: 24 }}>
        <div style={{ fontWeight: 700, fontSize: 16, textAlign: 'center', marginBottom: 15, letterSpacing: 2, textTransform: 'uppercase' }}>
          AS ON {periods.length > 0 ? periods[periods.length - 1].label : '---'} (QTY / PRINCIPAL / %)
        </div>
        {partiesList.map(party => {
          const data   = buildFinalSheetDataForParty(party);
          const purch  = Number(data?.raw?.purchases ?? 0);
          const gp     = Number(data?.raw?.grossProfit ?? 0);
          const gpPct  = purch > 0 ? (gp / purch) * 100 : 0;
          const rows2  = [
            { label: 'GROSS PROFIT (%)', values: periods.map(() => gpPct), isPercent: true },
            { label: 'Less: interest charged by us', values: periods.map(() => -interestPercentage), isPercent: true },
            { label: `Our net profit after ${interestPercentage}% interest`, values: periods.map(() => gpPct - interestPercentage), isPercent: true },
          ];
          return (
            <div key={party.id} style={{ border: '1px solid #222', marginBottom: 24, borderRadius: 6, background: '#f9f9ff', overflow: 'hidden' }}>
              <div style={{ fontWeight: 700, fontSize: 18, padding: '10px 12px', background: '#efeefe', borderBottom: '1.5px solid #d1cdf4', color: '#6742c7' }}>{farmForm.name}</div>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ minWidth: 350, background: '#f2f2f2', border: '1px solid #aaa', textAlign: 'left', padding: '12px', fontSize: 14 }}>
                        {`${party.name.toUpperCase()} START FROM ${new Date(party.date).toLocaleDateString('en-GB')} (Total Capital ${Number(party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })})`}
                      </th>
                      {periods.map(p => (
                        <th key={p.key} style={{ minWidth: 160, background: '#e9e6fd', border: '1px solid #aaa', textAlign: 'center', padding: '8px 5px' }}>
                          <div style={{ fontSize: '13px', fontWeight: 700 }}>{p.label}</div>
                          <div style={{ fontSize: '11px', color: '#555' }}>(Sensex {p.sensex})</div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows2.map((row, ri) => (
                      <tr key={ri}>
                        <td style={{ padding: '10px 12px', background: '#fff', border: '1px solid #aaa', fontWeight: 600, fontSize: 14, color: '#444' }}>{row.label}</td>
                        {row.values.map((v, vi) => (
                          <td key={vi} style={{ textAlign: 'right', padding: '8px 10px', fontSize: 13, background: vi % 2 === 1 ? '#f6f6fb' : '#fff', border: '1px solid #ccc' }}>{fmt2(v, row.isPercent)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  const onPrint = (boxid: string) => {
    const box = document.getElementById(boxid);
    if (!box) return;
    document.body.innerHTML = box.innerHTML;
    window.print();
  };

  const filteredData = React.useMemo(() => {
    let arr = partyAggregatedRows;
    if (partyIdFromUrl) arr = arr.filter(r => String(r.party.id) === String(partyIdFromUrl));
    if (search) arr = arr.filter(r => r.party.name?.toLowerCase().includes(search.toLowerCase()));
    Object.entries(filters).forEach(([key, value]) => { if (!value) return; if (key === 'party_name') arr = arr.filter(r => r.party.name?.toLowerCase() === String(value).toLowerCase()); });
    return arr;
  }, [partyAggregatedRows, search, filters, partyIdFromUrl]);

  const totalPage = Math.ceil(filteredData.length / perPage) || 1;
  const pageData  = filteredData.slice((page - 1) * perPage, page * perPage);

  function handleExportCSV() {
    const csv = [['Party Name','Contact Person','Contact Number','Total Purchased','Total Used','Total Earning'].join(','),
      ...pageData.map(r => [r.party.name,r.party.contact_person_name,r.party.contact_person_number,r.total_purchased,r.total_used,r.total_earning].map((v:any) => `"${v!=null?String(v).replace(/"/g,'""'):''}"`).join(','))];
    downloadCSV(csv.join('\r\n'), 'party_balance_sheet.csv');
  }

  useEffect(() => {
    if (!showPartyModal) return;
    const h = (e: KeyboardEvent) => { if (e.key === 'Escape') setShowPartyModal(false); };
    window.addEventListener('keydown', h);
    return () => window.removeEventListener('keydown', h);
  }, [showPartyModal]);

  function renderPartyModal() {
    if (!selectedParty) return null;
    const row = partyAggregatedRows.find(r => r.party.id === selectedParty.id);
    if (!row) return null;
    return (
      <div className="fixed top-0 left-0 right-0 bottom-0 z-40 bg-black/40 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-6 min-w-[350px] w-[96vw] max-w-5xl relative max-h-[90vh] overflow-auto">
          <button className="absolute top-3 right-4 text-2xl text-gray-400 hover:text-gray-600" onClick={() => setShowPartyModal(false)}>&times;</button>
          <h2 className="text-2xl font-bold mb-2 text-[#6742c7]">{row.party.name}</h2>
          <div className="mb-2 text-sm text-[#6742c7] font-medium flex items-center gap-2">
            <span>Showing data for:</span>
            <span className="bg-[#F3F0FD] px-2 rounded text-[#4f30a3]">{formatPeriod(dateFrom, dateTo)}</span>
          </div>
          <div className="mb-4 flex flex-wrap gap-2">
            {(['overall','final','balance','QTLY Performance'] as ModalSheetView[]).map(tab => (
              <button key={tab}
                className={`px-3 py-1 rounded font-semibold border text-sm transition ${partyModalSheet === tab ? 'bg-[#6742c7] text-white border-[#6742c7]' : 'bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]'}`}
                onClick={() => setPartyModalSheet(tab)}>
                {tab === 'final' ? 'Final (P&L)' : tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {partyModalSheet === 'overall' && (
            <>
              <div className="mb-6 grid gap-4 md:grid-cols-3">
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#7964e7] px-5 py-4">
                  <div className="font-medium text-[#7964e7] uppercase text-xs mb-2 tracking-widest">Contact</div>
                  <span className="block text-gray-700 font-semibold">{row.party.contact_person_name || '-'}</span>
                  <span className="block text-gray-500">{row.party.contact_person_number || '-'}</span>
                </div>
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#41c6c4] px-5 py-4">
                  <div className="font-medium text-[#41c6c4] uppercase text-xs mb-2 tracking-widest">Opening Balance</div>
                  <div className="text-xl font-extrabold">{row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '-'}</div>
                </div>
                <div className="bg-white rounded-2xl shadow border-l-4 border-[#ffa629] px-5 py-4">
                  <div className="font-medium text-[#ffa629] uppercase text-xs mb-2 tracking-widest">Summary</div>
                  <div className="flex justify-between"><span className="text-gray-600">Purchased</span><span className="font-bold">{typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN',{minimumFractionDigits:2})}` : row.total_purchased}</span></div>
                  <div className="flex justify-between pt-2 border-t mt-2"><span className="text-gray-600">Total Sold</span><span className="font-bold">{row.total_sales_amount !== undefined ? `₹${Number(row.total_sales_amount).toLocaleString('en-IN',{minimumFractionDigits:2})}` : '-'}</span></div>
                  <div className="flex justify-between"><span className="text-gray-600">Units Sold</span><span className="font-bold">{row.total_sales_units ?? '-'}</span></div>
                </div>
              </div>

              {/* Closing amounts from DB */}
              {partyClosingAmounts[String(row.party.id)] !== undefined && (
                <div className="mb-4 p-3 bg-[#E1F5EE] border border-[#5DCAA5] rounded-xl flex items-center gap-3">
                  <span className="text-[#085041] font-semibold text-sm">Closing Stock (from saved records):</span>
                  <span className="text-[#085041] font-bold text-lg">₹{partyClosingAmounts[String(row.party.id)].toLocaleString('en-IN',{minimumFractionDigits:2})}</span>
                </div>
              )}

              {row.withdrawals_details && row.withdrawals_details.length > 0 && (
                <div className="mb-6">
                  <h3 className="font-extrabold text-lg text-[#e65a23] mb-3">Withdrawals</h3>
                  <div className="overflow-x-auto border border-orange-100 rounded-2xl">
                    <table className="w-full text-sm">
                      <thead className="bg-orange-50"><tr>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Date</th>
                        <th className="px-3 py-2 text-right text-[#e76a28]">Amount</th>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Category</th>
                        <th className="px-3 py-2 text-left text-[#e76a28]">Stock</th>
                      </tr></thead>
                      <tbody>
                        {row.withdrawals_details.map((wd: any) => {
                          let cats: any[] = [];
                          if (wd.catrgories) { try { const a = JSON.parse(wd.catrgories); if (Array.isArray(a) && typeof a[0] === 'string') { cats = JSON.parse(a[0]); if (!Array.isArray(cats)) cats = [cats]; } } catch {} }
                          return (
                            <tr key={wd.id} className="border-t">
                              <td className="px-3 py-2">{wd.date ? new Date(wd.date).toLocaleDateString('en-IN',{year:'numeric',month:'short',day:'numeric'}) : '-'}</td>
                              <td className="px-3 py-2 text-right font-bold text-[#dd661a]">{wd.amount ? `₹${Number(wd.amount).toLocaleString('en-IN',{minimumFractionDigits:2})}` : '-'}</td>
                              <td className="px-3 py-2">{cats.map((c:any) => c.category).join(', ') || '-'}</td>
                              <td className="px-3 py-2">{cats.map((c:any) => c.stockName).join(', ') || '-'}</td>
                            </tr>
                          );
                        })}
                        <tr className="bg-orange-50 font-bold border-t">
                          <td className="px-3 py-2">Total</td>
                          <td className="px-3 py-2 text-right text-[#e65a23]">{`₹${row.withdrawals_details.reduce((s:number,w:any) => s+(parseFloat(String(w.amount))||0),0).toLocaleString('en-IN',{minimumFractionDigits:2})}`}</td>
                          <td colSpan={2}/>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <h3 className="font-bold text-[#6742c7] text-lg mb-3">Stocks (Details per Category)</h3>
              <div className="overflow-x-auto max-h-[370px]">
                {row.stocks.length === 0 && <div className="p-10 text-center text-gray-400 italic">No stocks found for this party.</div>}
                {row.stocks.map((s: any, i: number) => (
                  <div key={i} className="mb-6 border border-[#f1ecff] rounded-xl overflow-hidden">
                    <div className="bg-[#6742c7] px-5 py-3"><span className="font-bold text-white">{s.stock_name}</span></div>
                    <table className="w-full text-[13px]">
                      <thead className="bg-[#ece6fa]"><tr>{['Category','Unit','Purchase Date','Purchase Amt','Indirect Charges','History'].map(h => <th key={h} className="p-2 text-center text-[#6742c7] font-semibold">{h}</th>)}</tr></thead>
                      <tbody>
                        {s.records.map((rec: any, ridx: number) => (
                          <tr key={ridx} className="border-t text-center">
                            <td className="p-2">{rec.category}</td>
                            <td className="p-2">{rec.unit}</td>
                            <td className="p-2">{rec.date_of_purchase ? new Date(rec.date_of_purchase).toLocaleDateString('en-IN',{year:'numeric',month:'short',day:'numeric'}) : '-'}</td>
                            <td className="p-2">{`₹${Number(rec.opening_balance).toLocaleString('en-IN',{minimumFractionDigits:2})}`}</td>
                            <td className="p-2">{`₹${Number(rec.indirect_charges).toLocaleString('en-IN',{minimumFractionDigits:2})}`}</td>
                            <td className="p-2">
                              {rec.update_history.length === 0 ? <span className="text-gray-400 italic">No updates</span> : (
                                <table className="w-full text-[11px] border">
                                  <thead className="bg-[#f8f6ff]"><tr>{['Date','Amount','Ind. Income','P/L'].map(h => <th key={h} className="px-1 py-1 border-b">{h}</th>)}</tr></thead>
                                  <tbody>
                                    {rec.update_history.slice(0,3).map((up:any,ui:number) => (
                                      <tr key={ui} className="text-center">
                                        <td className="px-1 py-1">{up.date ? new Date(up.date).toLocaleDateString('en-IN',{month:'short',day:'numeric'}) : '-'}</td>
                                        <td className="px-1 py-1">{`₹${Number(up.current_amount).toLocaleString('en-IN',{minimumFractionDigits:2})}`}</td>
                                        <td className="px-1 py-1">{up.dividend ? `₹${Number(up.dividend).toLocaleString('en-IN',{minimumFractionDigits:2})}` : '-'}</td>
                                        <td className={`px-1 py-1 font-semibold ${up.profitAndLoss>=0?'text-green-600':'text-red-500'}`}>{`₹${Number(up.profitAndLoss).toLocaleString('en-IN',{minimumFractionDigits:2})}`}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
              </div>
            </>
          )}

          {partyModalSheet === 'final' && (
            <>{renderPnLModalContent(row.party)}<div className="flex justify-end mt-4"><button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('renderpnl')}>Print/Download</button></div></>
          )}
          {partyModalSheet === 'balance' && (
            <>{renderBalanceSheetModalContent(row.party)}<div className="flex justify-end mt-4"><button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('balancesheet')}>Print/Download</button></div></>
          )}
          {partyModalSheet === 'QTLY Performance' && (
            <><div id="qtlydata">{renderQTLYContent([row.party])}</div><div className="flex justify-end mt-4"><button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded hover:bg-[#442293]" onClick={() => onPrint('qtlydata')}>Print/Download</button></div></>
          )}
        </div>
      </div>
    );
  }

  const FinancialSummaryBadges = ({ partyId }: { partyId: string }) => (
    <div className="flex flex-wrap gap-1">
      {ENTRY_TYPES.map(({ type, label, color, bg, border }) => {
        const recs  = getFilteredRecords(partyId, type, dateFrom, dateTo);
        const total = sumRecords(recs);
        return (
          <button key={type} onClick={() => setEntryModal({ isOpen: true, type, partyId })}
            className="flex items-center gap-1 px-2 py-1 rounded-lg text-[11px] font-semibold border transition hover:opacity-80"
            style={{ borderColor: border, color, background: bg }}
            title={`${label}: ₹${total.toLocaleString('en-IN',{minimumFractionDigits:2})} — click to edit`}>
            {label}
            {recs.length > 0 ? <span className="font-bold">₹{total.toLocaleString('en-IN',{minimumFractionDigits:0})}</span> : <span className="opacity-50">+</span>}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="p-6 min-h-screen" style={{ background: 'linear-gradient(120deg,#fff 0%,#f8fffd 100%)' }}>
      {showPartyModal && renderPartyModal()}

      {entryModal.isOpen && (
        <MultiEntryForm
          type={entryModal.type}
          partyId={entryModal.partyId}
          partyName={parties.find(p => String(p.id) === entryModal.partyId)?.name || ''}
          existingRecords={financialRecords.filter(r => String(r.party_id) === entryModal.partyId && r.record_type === entryModal.type)}
          onClose={() => setEntryModal(e => ({ ...e, isOpen: false }))}
          onSaved={loadFinancialRecords}
        />
      )}

      {globalQTLY && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center">
          <div className="relative bg-white rounded-xl shadow-lg p-6 w-[96vw] max-w-5xl max-h-[90vh] overflow-auto border-2 border-[#408A71]">
            <button className="absolute top-3 right-4 text-2xl text-gray-400" onClick={() => setGlobalQtly(false)}>&times;</button>
            <div id="globalQtly">{renderQTLYContent(parties)}</div>
            <div className="flex justify-end mt-4"><button className="px-4 py-2 text-sm bg-[#6742c7] text-white font-bold rounded" onClick={() => onPrint('globalQtly')}>Print/Download</button></div>
          </div>
        </div>
      )}

      {!wizardDone ? (
        <div className="max-w-2xl mx-auto">
          <div className="mb-6">
            <h1 className="text-[26px] font-semibold text-gray-900">Party Balance Sheet</h1>
            <p className="text-[13px] text-gray-500 mt-1">Configure your filters and entries before generating the report.</p>
          </div>
          <StepBar current={wizardStep} />
          <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm">
            {wizardStep === 1 && <Step1InvestmentType selected={selectedStockType} onSelect={setSelectedStockType} onNext={() => setWizardStep(2)} />}
            {wizardStep === 2 && (
              <Step2DateRange
                stockType={selectedStockType}
                dateFrom={wizardDateFrom} setDateFrom={setWizardDateFrom}
                dateTo={wizardDateTo}     setDateTo={setWizardDateTo}
                interestDateTo={interestDateTo} setInterestDateTo={setInterestDateTo}
                interestRate={interestPercentage} setInterestRate={setInterestPercentage}
                mutualPeriods={mutualPeriods} setMutualPeriods={setMutualPeriods}
                onBack={() => setWizardStep(1)} onNext={() => setWizardStep(3)}
              />
            )}
            {wizardStep === 3 && (
              <Step3FinancialEntries
                parties={parties} financialRecords={financialRecords}
                onSaved={loadFinancialRecords}
                onBack={() => setWizardStep(2)} onNext={() => setWizardStep(4)}
              />
            )}
            {wizardStep === 4 && (
              <Step4Review
                stockType={selectedStockType} dateFrom={wizardDateFrom} dateTo={wizardDateTo}
                interestRate={interestPercentage} interestDateTo={interestDateTo}
                mutualPeriods={mutualPeriods} financialRecords={financialRecords} parties={parties}
                onBack={() => setWizardStep(3)} onGenerate={generateBalanceSheet}
              />
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className="flex flex-wrap justify-between items-center gap-3 w-full mb-5">
            <div className="flex items-center gap-3 flex-wrap">
              <h1 className="text-[26px] font-[600]">Party Balance Sheet</h1>
              <div className="bg-[#EEEDFE] px-3 py-1 rounded-full border border-[#AFA9EC]">
                <span className="text-[#534AB7] text-[12px] font-semibold">{parties.length} parties</span>
              </div>
              <span className="inline-flex items-center px-3 py-1 rounded-full text-[12px] font-medium bg-[#EEEDFE] text-[#534AB7] border border-[#AFA9EC]">
                {STOCK_TYPES.find(t => t.key === selectedStockType)?.label}
              </span>
              {(dateFrom || dateTo) && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-[12px] font-medium bg-[#EEEDFE] text-[#534AB7] border border-[#AFA9EC]">
                  {formatPeriod(dateFrom, dateTo)}
                </span>
              )}
            </div>
            <div className="flex gap-2 items-center flex-wrap">
              <button onClick={resetWizard} className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#534AB7] border-[#534AB7] hover:bg-[#EEEDFE] transition">← Change filters</button>
              <button className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#1CAC70] border-[#1CAC70] hover:bg-[#E6F8F0] hidden" onClick={() => (window.location.href='/mutual-balance-sheet')}>Mutual Balance Sheet</button>
              <button className="px-3 py-2 rounded-lg font-semibold border text-sm bg-white text-[#6742c7] border-[#6742c7] hover:bg-[#F3F0FD]" onClick={() => setGlobalQtly(true)}>QTLY Performance</button>
              <button className="flex items-center gap-1 border border-[#D0D5DD] bg-white py-2 px-4 rounded-lg text-sm" onClick={() => fileInputRef.current?.click()}><BiImport /> Import</button>
              <input ref={fileInputRef} type="file" accept=".csv" style={{ display: 'none' }} />
              <button className="flex items-center gap-1 border border-[#1CAC70] bg-[#E6F8F0] py-2 px-4 rounded-lg text-[#1CAC70] font-semibold text-sm" onClick={handleExportCSV}>Export CSV</button>
            </div>
          </div>

          <div className="flex justify-between items-center gap-3 mb-4 flex-wrap">
            <div className="bg-white h-[38px] flex items-center rounded-lg px-2 border border-[#D0D5DD] gap-1 min-w-[280px]">
              <CiSearch className="text-[#8488B7] text-[22px]" />
              <input type="text" placeholder="Search party name…" className="w-full bg-transparent h-[32px] focus:outline-none text-sm"
                value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} />
            </div>
            <div className="text-[12px] text-gray-500">
              Showing data for: <span className="font-semibold text-[#534AB7]">{formatPeriod(dateFrom, dateTo)}</span>
            </div>
          </div>

          <div className="max-w-full overflow-x-auto border border-gray-200 rounded-xl shadow-sm">
            <table className="w-full border-collapse table-auto">
              <thead className="bg-gradient-to-r from-white to-[#EBF9F4]">
                <tr>
                  <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Party name</th>
                  <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Contact person</th>
                  <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Contact number</th>
                  <th className="px-3 py-3 text-left text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Total amount</th>
                  <th className="px-3 py-3 text-right text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Total purchased</th>
                  <th className="px-3 py-3 text-center text-[13px] font-semibold text-[#6742c7] border-b whitespace-nowrap">Actions &amp; entries</th>
                </tr>
              </thead>
              <tbody>
                {pageData.length === 0 ? (
                  <tr><td colSpan={6} className="text-center py-8 text-gray-400 font-semibold">No data found.</td></tr>
                ) : (
                  pageData.map(row => (
                    <tr key={row.party.id} className="hover:bg-gray-50/50 transition align-top">
                      <td className="px-3 py-3 text-sm font-semibold text-[#101828] border-b whitespace-nowrap">{row.party.name}</td>
                      <td className="px-3 py-3 text-sm text-[#344054] border-b whitespace-nowrap">{row.party.contact_person_name}</td>
                      <td className="px-3 py-3 text-sm text-[#344054] border-b whitespace-nowrap">{row.party.contact_person_number}</td>
                      <td className="px-3 py-3 text-sm font-medium text-[#101828] border-b whitespace-nowrap">
                        {row.party.total_amount !== undefined ? `₹${Number(row.party.total_amount).toLocaleString('en-IN',{minimumFractionDigits:2})}` : '-'}
                      </td>
                      <td className="px-3 py-3 text-sm font-medium text-[#344054] border-b whitespace-nowrap text-right">
                        {typeof row.total_purchased === 'number' ? `₹${row.total_purchased.toLocaleString('en-IN',{minimumFractionDigits:2})}` : row.total_purchased}
                      </td>
                      <td className="px-3 py-3 border-b flex gap-1">
                        <button onClick={() => { setSelectedParty(row.party); setShowPartyModal(true); setPartyModalSheet('overall'); }}
                          className="flex items-center gap-1 text-[#6742C6] text-[11px] px-2 py-1 rounded-lg border border-[#dcd7ee] hover:border-[#6742C6] bg-white hover:bg-[#f6f4fd] font-medium transition">
                          <FaEye /> View
                        </button>
                        <FinancialSummaryBadges partyId={String(row.party.id)} />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between mt-4">
            <span className="text-[#344054] text-[14px]">Page {page} of {totalPage}</span>
            <div className="flex gap-2">
              <button disabled={page === 1} onClick={() => setPage(p => p-1)} className="px-3 py-1 bg-white text-[#344054] border rounded-lg disabled:opacity-40">Previous</button>
              <button disabled={page === totalPage || filteredData.length === 0} onClick={() => setPage(p => p+1)} className="px-3 py-1 bg-white text-[#344054] border rounded-lg disabled:opacity-40">Next</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UnifiedBalanceSheet;